<template>
  <div>
    <b-card no-body>
      <b-card-body class="px-2 pt-2 pb-0">
        <b-row>
          <b-col lg="4" md="6" sm="12" class="text-left mb-1">
            <b-form-group label-for="filterInput" class="mb-0">
              <b-button variant="gradient-primary" size="sm" class="mr-1" @click="traerLotesValvulas"
                        :disabled="loading"
                        v-b-tooltip.hover.top="'Recargar Datos'">
                <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
              </b-button>
              <b-button v-if="$can('create', 'Pr Man Lotes')" variant="gradient-primary" size="sm" class="mr-1"
                        :disabled="loadingExp" @click="exportarDataExcel" v-b-tooltip.hover.top="'Descargar Excel'">
                <font-awesome-icon v-if="loadingExp" icon="fa-solid fa-arrows-rotate" spin/>
                <font-awesome-icon v-else icon="fa-solid fa-download"/>
              </b-button>
              <b-button v-if="$can('create', 'Pr Man Lotes')" variant="gradient-primary" size="sm" class="mr-1"
                        :disabled="loadingExp" @click="borrarFiltroGeneral" v-b-tooltip.hover.top="'Limpiar Filtro'">
                <font-awesome-icon icon="fa-solid fa-filter-circle-xmark"/>
              </b-button>
              <b-button
                  variant="gradient-primary"
                  size="sm"
                  v-if="$can('create', 'Pr Man Lotes')"
                  @click="mostrarModalImportar(true)"
                  v-b-tooltip.hover="'Importar Registros'"
                  class="mr-1"
              >
                <font-awesome-icon icon="fa-solid fa-file-excel"/>
              </b-button>
              <b-button
                  variant="gradient-primary"
                  size="sm"
                  v-if="$can('create', 'Pr Man Lotes')"
                  @click="mostrarModalVersionar(true)"
                  v-b-tooltip.hover="'Versionar'"
                  class="mr-1"
              >
                <font-awesome-icon icon="fa-solid fa-sliders"/>
              </b-button>

            </b-form-group>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="text-center mb-1 font-medium-1 text-bold font-weight-bold">
            Total: {{ itemsFiltro.length }} registros
          </b-col>
          <b-col lg="2" md="6" sm="12" class="text-center mb-1 font-medium-1 text-bold font-weight-bold">
            {{ version_elegida }} | {{ subversion_elegida }}
          </b-col>
          <b-col lg="2" md="2" sm="12" class="text-right mb-1">
            <div class="d-flex align-items-center justify-content-end">
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filter" @input="filtrarPorBusqueda(true)" type="search"
                              placeholder="Buscar Cód. Homologado" no-clearable/>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filtrarPorBusqueda(false)">
                    Borrar
                  </b-button>
                </b-input-group-append>
                <!-- <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Buscar Cód. Homologado" />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">
                    Borrar
                  </b-button>
                </b-input-group-append> -->
              </b-input-group>
            </div>
          </b-col>
        </b-row>

      </b-card-body>

      <!-- :filter="filter"
      :filter-included-fields="filterOn"  -->
      <b-table
          hover
          responsive
          small
          sticky-header="58vh"
          class="position-relative"
          :items="itemsFiltro"
          :fields="fields"
          :busy="loading" show-empty
          empty-text="No se encontraron datos en esta tabla."
          emptyFilteredText="No se encontraron datos con los parámetros ingresados."
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
        <!-- <template #cell(area_sembrada)="data">
          {{ data.value.toFixed(3) }}
        </template> -->
        <template #cell(show_details)="row">

          <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
          <div class="text-nowrap text-left">
            <feather-icon :icon="row.detailsShowing ? 'EyeOffIcon' : 'EyeIcon'" size="16"
                          v-b-tooltip.hover.top="row.detailsShowing ? 'Ocultar Datos' : 'Mostrar Datos'"
                          @click="row.toggleDetails" ref="holi"/>
            <feather-icon v-if="$can('create', 'Pr Man Lotes')" :id="`btn_${row.item.id}_crear`" icon="PlusIcon"
                          size="16" class="ml-1" @click="mostrarModalCrear(row.item)"
                          v-b-tooltip.hover.top="'Registrar Válvula - Lote'"/>
            <!-- <feather-icon v-if="$can('create', 'Pr Man Lotes')" :id="`btn_${row.item.id}_editare`" icon="EditIcon"
              size="16" class="ml-1" @click="mostrarModalEditar(row.item, true)"
              v-b-tooltip.hover.top="'Editar Estado'" /> -->
            <feather-icon v-if="$can('update', 'Pr Man Lotes')" :id="`btn_${row.item.id}_dividir`" icon="LayoutIcon"
                          size="16" class="ml-1" @click="dividirRegistro(row.item)"
                          v-b-tooltip.hover.top="'Asignar Combinación'"/>
            <!-- <b-badge :variant="status_turno[1][parseInt(row.item.estado_id)]" class="ml-1">
              {{ status_turno[0][parseInt(row.item.estado_id)] }}
            </b-badge> -->
          </div>
        </template>

        <template #row-details="row">
          <div class="m-1">
            <b-table :items="buscarGrupoPorCodHomologadoTurno(row.item.cod_homologado)" :fields="fields2" hover
                     style="width: 40%!important;" show-empty empty-text="No hay datos.">
              <!-- <template #cell(estado)="data">
                <b-badge :variant="status_lotevalvula[1][parseInt(data.value)]">
                  {{ status_lotevalvula[0][parseInt(data.value)] }}
                </b-badge>
              </template> -->
              <template #cell(acciones)="data">
                <feather-icon :id="`btn_${data.item.id}_editarss`" icon="EditIcon" size="16"
                              @click="mostrarModalEditar(data.item, false)" v-b-tooltip.hover.top="'Editar Estado'"/>
              </template>
            </b-table>
          </div>
        </template>

        <template #head(sociedad)>
          <div class="text-nowrap">
            <b-dropdown menu-class="" size="sm" variant="btn"
                        :toggle-class="`${sociedad_filtro.length > 0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                        :style="`${sociedad_filtro.length > 0 ? 'text-decoration: underline #fba820e6;' : ''}`">
              <template #button-content>
                <b>SOCIEDAD</b>
              </template>
              <b-dropdown-form style="width: 250px!important;">
                <b-form-group label="Filtrar Sociedad" label-for="sociedad_filtro" @click.prevent class="py-0 my-0">
                  <v-select id="sociedad_filtro" v-model="sociedad_filtro" :options="sociedadFiltro" multiple
                            placeholder="Seleccionar sociedad ..." @input="realizarFiltro('sociedad', sociedad_filtro)"
                            class="select-size-sm"/>
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="sociedad_filtro = []; realizarFiltro('sociedad', [])">
                <feather-icon class="mr-1" icon="DeleteIcon"/>
                <span class="align-middle">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
        <template #head(fundo)>
          <div class="text-nowrap">
            <b-dropdown menu-class="" size="sm" variant="btn"
                        :toggle-class="`${fundo_filtro.length > 0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                        :style="`${fundo_filtro.length > 0 ? 'text-decoration: underline #fba820e6;' : ''}`">
              <template #button-content>
                <b>FUNDO</b>
              </template>
              <b-dropdown-form style="width: 250px!important;">
                <b-form-group label="Filtrar Fundo" label-for="fundo_filtro" @click.prevent class="py-0 my-0">
                  <v-select id="fundo_filtro" v-model="fundo_filtro" :options="fundoFiltro" multiple
                            placeholder="Seleccionar fundo ..." @input="realizarFiltro('fundo', fundo_filtro)"
                            class="select-size-sm"/>
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="fundo_filtro = []; realizarFiltro('fundo', [])">
                <feather-icon class="mr-1" icon="DeleteIcon"/>
                <span class="align-middle">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
        <template #head(cultivo)>
          <div class="text-nowrap">
            <b-dropdown menu-class="" size="sm" variant="btn"
                        :toggle-class="`${cultivo_filtro.length > 0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                        :style="`${cultivo_filtro.length > 0 ? 'text-decoration: underline #fba820e6;' : ''}`">
              <template #button-content>
                <b>CULTIVO</b>
              </template>
              <b-dropdown-form style="width: 250px!important;">
                <b-form-group label="Filtrar Cultivo" label-for="cultivo_filtro" @click.prevent class="py-0 my-0">
                  <v-select id="cultivo_filtro" v-model="cultivo_filtro" :options="cultivoFiltro" multiple
                            placeholder="Seleccionar cultivo ..." @input="realizarFiltro('cultivo', cultivo_filtro)"
                            class="select-size-sm"/>
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="cultivo_filtro = []; realizarFiltro('cultivo', [])">
                <feather-icon class="mr-1" icon="DeleteIcon"/>
                <span class="align-middle">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
        <template #head(etapa)>
          <div class="text-nowrap">
            <b-dropdown menu-class="" size="sm" variant="btn"
                        :toggle-class="`${etapa_filtro.length > 0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                        :style="`${etapa_filtro.length > 0 ? 'text-decoration: underline #fba820e6;' : ''}`">
              <template #button-content>
                <b>ETAPA</b>
              </template>
              <b-dropdown-form style="width: 250px!important;">
                <b-form-group label="Filtrar Etapa" label-for="etapa_filtro" @click.prevent class="py-0 my-0">
                  <v-select id="etapa_filtro" v-model="etapa_filtro" :options="etapaFiltro" multiple
                            placeholder="Seleccionar etapa ..." @input="realizarFiltro('etapa', etapa_filtro)"
                            class="select-size-sm"/>
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="etapa_filtro = []; realizarFiltro('etapa', [])">
                <feather-icon class="mr-1" icon="DeleteIcon"/>
                <span class="align-middle">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
        <template #head(campo)>
          <div class="text-nowrap">
            <b-dropdown menu-class="" size="sm" variant="btn"
                        :toggle-class="`${campo_filtro.length > 0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                        :style="`${campo_filtro.length > 0 ? 'text-decoration: underline #fba820e6;' : ''}`">
              <template #button-content>
                <b>CAMPO</b>
              </template>
              <b-dropdown-form style="width: 250px!important;">
                <b-form-group label="Filtrar Campo" label-for="campo_filtro" @click.prevent class="py-0 my-0">
                  <v-select id="campo_filtro" v-model="campo_filtro" :options="campoFiltro" multiple
                            placeholder="Seleccionar campo ..." @input="realizarFiltro('campo', campo_filtro)"
                            class="select-size-sm"/>
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="campo_filtro = []; realizarFiltro('campo', [])">
                <feather-icon class="mr-1" icon="DeleteIcon"/>
                <span class="align-middle">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
        <template #head(variedad)>
          <div class="text-nowrap">
            <b-dropdown menu-class="" size="sm" variant="btn"
                        :toggle-class="`${variedad_filtro.length > 0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                        :style="`${variedad_filtro.length > 0 ? 'text-decoration: underline #fba820e6;' : ''}`">
              <template #button-content>
                <b>VARIEDAD</b>
              </template>
              <b-dropdown-form style="width: 250px!important;">
                <b-form-group label="Filtrar Variedad" label-for="variedad_filtro" @click.prevent class="py-0 my-0">
                  <v-select id="variedad_filtro" v-model="variedad_filtro" :options="variedadFiltro" multiple
                            placeholder="Seleccionar variedad ..." @input="realizarFiltro('variedad', variedad_filtro)"
                            class="select-size-sm"/>
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="variedad_filtro = []; realizarFiltro('variedad', [])">
                <feather-icon class="mr-1" icon="DeleteIcon"/>
                <span class="align-middle">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
        <template #head(turno)>
          <div class="text-nowrap">
            <b-dropdown menu-class="" size="sm" variant="btn"
                        :toggle-class="`${turno_filtro.length > 0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                        :style="`${turno_filtro.length > 0 ? 'text-decoration: underline #fba820e6;' : ''}`">
              <template #button-content>
                <b>TURNO</b>
              </template>
              <b-dropdown-form style="width: 250px!important;">
                <b-form-group label="Filtrar Turno" label-for="turno_filtro" @click.prevent class="py-0 my-0">
                  <v-select id="turno_filtro" v-model="turno_filtro" :options="turnoFiltro" multiple
                            placeholder="Seleccionar turno ..." @input="realizarFiltro('turno', turno_filtro)"
                            class="select-size-sm"/>
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="turno_filtro = []; realizarFiltro('turno', [])">
                <feather-icon class="mr-1" icon="DeleteIcon"/>
                <span class="align-middle">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
      </b-table>
    </b-card>

    <b-modal id="modal-editar" ref="modal-editar" v-model="estadoModalEditar" title="Editar Registro" ok-title="Editar"
             cancel-title="Cancelar" cancel-variant="outline-secondary" size="sm" centered :ok-disabled="loadingEditar"
             :cancel-disabled="loadingEditar" no-close-on-esc no-close-on-backdrop @show="" @hidden="resetModal"
             @ok="validacionEditar">
      <div v-if="loadingEditar" align="center">
        <p>Editando ... </p>
        <b-spinner label="Editando..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioEditar" #default="{ invalid }">
        <b-form autocomplete="off" @submit.prevent="editarEstado">
          <b-row>
            <!--
            <b-col lg="6">
              <b-form-group
                  label="Empresa"
                  label-for="empresa_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Empresa"
                    vid="empresa_e"
                    rules="required"
                >
                  <b-form-input
                      id="empresa_e"
                      v-model="empresa"
                      :state="errors.length > 0 ? false:null"
                      name="empresa_e"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                  label="Fundo"
                  label-for="fundo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Fundo"
                    vid="fundo_e"
                    rules="required"
                >
                  <b-form-input
                      id="fundo_e"
                      v-model="fundo"
                      :state="errors.length > 0 ? false:null"
                      name="fundo_e"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group
                  label="Etapa"
                  label-for="etapa_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Etapa"
                    vid="etapa_e"
                    rules="required"
                >
                  <b-form-input
                      id="etapa_e"
                      v-model="etapa"
                      :state="errors.length > 0 ? false:null"
                      name="etapa_e"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                  label="Campo"
                  label-for="campo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Campo"
                    vid="campo_e"
                    rules="required"
                >
                  <b-form-input
                      id="campo_e"
                      v-model="campo"
                      :state="errors.length > 0 ? false:null"
                      name="campo_e"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                  label="Turno"
                  label-for="turno_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Turno"
                    vid="turno_e"
                    rules="required"
                >
                  <b-form-input
                      id="turno_e"
                      v-model="turno"
                      :state="errors.length > 0 ? false:null"
                      name="turno_e"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="6">
              <b-form-group
                  label="Lote"
                  label-for="lote_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Lote"
                    vid="lote_e"
                    rules="required"
                >
                  <b-form-input
                      id="lote_e"
                      v-model="lote"
                      :state="errors.length > 0 ? false:null"
                      name="lote_e"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                  label="Válvula"
                  label-for="valvula_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Válvula"
                    vid="valvula_e"
                    rules="required"
                >
                  <b-form-input
                      id="valvula_e"
                      v-model="valvula"
                      :state="errors.length > 0 ? false:null"
                      name="valvula_e"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group
                  label="Cultivo"
                  label-for="cultivo_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Cultivo"
                    vid="cultivo_e"
                    rules="required"
                >
                  <b-form-input
                      id="cultivo_e"
                      v-model="cultivo"
                      :state="errors.length > 0 ? false:null"
                      name="cultivo_e"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                  label="Variedad"
                  label-for="variedad_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Variedad"
                    vid="variedad_e"
                    rules="required"
                >
                  <b-form-input
                      id="variedad_e"
                      v-model="variedad"
                      :state="errors.length > 0 ? false:null"
                      name="variedad_e"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                  label="Código Homologado"
                  label-for="cod_homologado_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Código Homologado"
                    vid="cod_homologado_e"
                    rules="required"
                >
                  <b-form-input
                      id="cod_homologado_e"
                      v-model="cod_homologado"
                      :state="errors.length > 0 ? false:null"
                      name="cod_homologado_e"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group
                  label="Área Total"
                  label-for="area_total"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Área Total"
                    vid="area_total"
                    rules="required"
                >
                  <b-form-input
                      id="area_total_e"
                      v-model="area_total"
                      :state="errors.length > 0 ? false:null"
                      name="area_total"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                  label="Área Sembrada"
                  label-for="area_sembrada_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Área Sembrada"
                    vid="area_sembrada_e"
                    rules="required"
                >
                  <b-form-input
                      id="area_sembrada_e"
                      v-model="area_sembrada"
                      :state="errors.length > 0 ? false:null"
                      name="area_sembrada_e"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          -->
            <b-col lg="12">
              <b-form-group
                  label="Código Homologado"
                  label-for="cod_homologado_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Código Homologado"
                    vid="cod_homologado_e"
                    rules="required"
                >
                  <b-form-input
                      id="cod_homologado_e"
                      v-model="cod_homologado"
                      :state="errors.length > 0 ? false:null"
                      name="cod_homologado_e"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="12">
              <b-form-group label="Estado Uno" label-for="estado_e">
                <validation-provider #default="{ errors }" name="Estado" vid="estado_e" rules="required">
                  <v-select id="estado_e" v-model="estado_uno" :options="estados" :reduce="estados => estados.value"
                            label="text" key="value" placeholder="Seleccionar estado..."/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="12">
              <b-form-group
                  label="Lote"
                  label-for="lote_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Lote"
                    vid="lote_e"
                    rules="required"
                >
                  <b-form-input
                      id="lote_e"
                      v-model="lote"
                      :state="errors.length > 0 ? false:null"
                      name="lote_e"
                      :disabled="isAgrup"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="12">
              <b-form-group
                  label="Válvula"
                  label-for="valvula_e"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Válvula"
                    vid="valvula_e"
                    rules="required"
                >
                  <b-form-input
                      id="valvula_e"
                      v-model="valvula"
                      :state="errors.length > 0 ? false:null"
                      name="valvula_e"
                      :disabled="isAgrup"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="12">
              <b-form-group
                  label="Área Subtotal"
                  label-for="area_subtotal"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Área Real"
                    vid="area_subtotal"
                    rules="required"
                >
                  <b-form-input
                      id="area_subtotal_e"
                      v-model="area_subtotal"
                      :state="errors.length > 0 ? false:null"
                      name="area_subtotal_e"
                      :disabled="isAgrup"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="12">
              <b-form-group
                  label="Área Real"
                  label-for="area_real"

              >
                <validation-provider
                    #default="{ errors }"
                    name="Área Real"
                    vid="area_real"
                    rules="required"
                >
                  <b-form-input
                      id="area_real_e"
                      v-model="area_real"
                      :state="errors.length > 0 ? false:null"
                      name="area_real_e"
                      @input="calcularDiferencia()"
                      :disabled="isAgrup"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="12">
              <b-form-group
                  label="Diferencia"
                  label-for="diferencia"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Diferencia"
                    vid="diferencia_e"
                    rules="required"
                >
                  <b-form-input
                      id="diferencia_e"
                      v-model="diferencia"
                      :state="errors.length > 0 ? false:null"
                      name="diferencia_e"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="12">
              <b-form-group label="Estado Dos" label-for="estado_dos_e">
                <validation-provider #default="{ errors }" name="Estado" vid="estado_e" rules="required">
                  <v-select id="estado_dos_e" v-model="estado_dos" :options="estados_dos"
                            :reduce="estados => estados.value"
                            label="text" key="value" placeholder="Seleccionar estado..."/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal id="modal-dividir" ref="modal-dividir" v-model="estadoModalDividir" title="Asignar Turnos y Válvulas"
             ok-title="Asignar" cancel-title="Cancelar" cancel-variant="outline-secondary" size="xl" centered
             :ok-disabled="loadingDividir" :cancel-disabled="loadingDividir" no-close-on-esc no-close-on-backdrop
             @show=""
             @hidden="resetModal" @ok="handleOk">
      <div v-if="loadingDividir" align="center">
        <p>Asignando ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioDividir" #default="{ invalid }">
        <b-form autocomplete="off" @submit.prevent="handleSubmit">
          <b-row>
            <b-col lg="3">
              <b-form-group label="Empresa" label-for="empresa">
                <validation-provider #default="{ errors }" name="Empresa" vid="empresa" rules="required">
                  <b-form-input id="empresa" v-model="empresa" :state="errors.length > 0 ? false : null" name="dias"
                                disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Fundo" label-for="fundo">
                <validation-provider #default="{ errors }" name="Fundo" vid="fundo" rules="required">
                  <b-form-input id="fundo" v-model="fundo" :state="errors.length > 0 ? false : null" name="fundo"
                                disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Etapa" label-for="etapa">
                <validation-provider #default="{ errors }" name="Etapa" vid="etapa" rules="required">
                  <b-form-input id="etapa" v-model="etapa" :state="errors.length > 0 ? false : null" name="etapa"
                                disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Campo" label-for="campo">
                <validation-provider #default="{ errors }" name="Campo" vid="campo" rules="required">
                  <b-form-input id="campo" v-model="campo" :state="errors.length > 0 ? false : null" name="campo"
                                disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group label="Turno" label-for="turno">
                <validation-provider #default="{ errors }" name="Turno" vid="turno" rules="required">
                  <b-form-input id="turno" v-model="turno" :state="errors.length > 0 ? false : null" name="turno"
                                disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group label="Cultivo" label-for="cultivo">
                <validation-provider #default="{ errors }" name="Cultivo" vid="cultivo" rules="required">
                  <b-form-input id="cultivo" v-model="cultivo" :state="errors.length > 0 ? false : null" name="cultivo"
                                disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Variedad" label-for="variedad">
                <validation-provider #default="{ errors }" name="Variedad" vid="variedad" rules="required">
                  <b-form-input id="variedad" v-model="variedad" :state="errors.length > 0 ? false : null"
                                name="variedad"
                                disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Área Total" label-for="area_total">
                <validation-provider #default="{ errors }" name="Área Total" vid="area_total" rules="required">
                  <b-form-input id="area_total" v-model="area_total" :state="errors.length > 0 ? false : null"
                                name="area_total" disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Código Homologado" label-for="cod_homologado">
                <validation-provider #default="{ errors }" name="Código Homologado" vid="cod_homologado"
                                     rules="required">
                  <b-form-input id="cod_homologado" v-model="cod_homologado" :state="errors.length > 0 ? false : null"
                                name="cod_homologado" disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Lotes Activos" label-for="lote">
                <validation-provider #default="{ errors }" name="Lote" vid="lote" rules="required">
                  <b-form-input id="lote" v-model="lote" :state="errors.length > 0 ? false : null" name="lote"
                                disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Valvulas Activas" label-for="valvula">
                <validation-provider #default="{ errors }" name="Valvula" vid="valvula" rules="required">
                  <b-form-input id="valvula" name="valvula" v-model="valvula_c"
                                :state="errors.length > 0 ? false : null"
                                disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- <b-col lg="3">
              <b-form-group label="Área Sembrada" label-for="area_sembrada">
                <validation-provider #default="{ errors }" name="Área Sembrada" vid="area_sembrada" rules="required">
                  <b-form-input id="area_sembrada" name="area_sembrada" v-model="area_sembrada"
                    :state="errors.length > 0 ? false : null" disabled />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <b-col cols="12">
              <hr>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Lote" label-for="lote_c">
                <validation-provider #default="{ errors }" name="Lote" vid="lote_c" rules="required">
                  <v-select id="lote_c" v-model="lote_c" name="lote_c" :options="lotes_activos" label="lote"
                            :state="errors.length > 0 ? false : null" placeholder="Seleccionar lotes..." multiple
                            @input="llenarCamposEnAutomatico"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Valvula" label-for="valvula_c">
                <validation-provider #default="{ errors }" name="Valvula" vid="valvula_c" rules="required">
                  <b-form-input id="valvula_c" name="valvula_c" v-model="valvula_c"
                                :state="errors.length > 0 ? false : null" disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group label="Área Subtotal" label-for="area_subtotal_c">
                <validation-provider #default="{ errors }" name="Área Subtotal" vid="area_subtotal_c" rules="required">
                  <b-form-input id="area_subtotal_c" name="area_subtotal_c" v-model="area_subtotal_c"
                                :state="errors.length > 0 ? false : null" disabled
                                @input="calcularDiferenciaEnAgrupado()"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group label="Área Real" label-for="area_real_c">
                <validation-provider #default="{ errors }" name="Área Real" vid="area_real_c" rules="required">
                  <b-form-input id="area_real_c" name="area_real_c" v-model="area_real_c"
                                :state="errors.length > 0 ? false : null" disabled
                                @input="calcularDiferenciaEnAgrupado()"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group label="Diferencia" label-for="diferencia_c">
                <validation-provider #default="{ errors }" name="Diferencia" vid="diferencia_c" rules="required">
                  <b-form-input id="diferencia_c" name="diferencia_c" v-model="diferencia_c"
                                :state="errors.length > 0 ? false : null" disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Código Homologado Nuevo" label-for="cod_homologado_c">
                <validation-provider #default="{ errors }" name="Código Homologado Nuevo" vid="cod_homologado_c"
                                     rules="required">
                  <b-form-input id="cod_homologado_c" v-model="cod_homologado_c"
                                :state="errors.length > 0 ? false : null"
                                name="cod_homologado_c" disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- <b-col lg="2">
              <div class="demo-inline-spacing">
                <b-form-checkbox v-model="estadoCorrelativo" :disabled="deshabilitar" @input="asignarCorrelativo">
                  Mantener Correlativo
                </b-form-checkbox>
              </div>
            </b-col> -->
          </b-row>

        </b-form>
      </validation-observer>
    </b-modal>


    <!-- <b-modal id="modal-unir" ref="modal-unir" v-model="estadoModalUnir" title="Unir Turno" ok-title="Unir"
      cancel-title="Cancelar" cancel-variant="outline-secondary" size="sm" centered :ok-disabled="false" no-close-on-esc
      no-close-on-backdrop @ok="unirTurno">
      <div v-if="loadingUnir" align="center">
        <p>Uniendo ... </p>
        <b-spinner label="Loading..." variant="primary" />
      </div>
      <div v-else align="center">
        <h3>¿Desea unir el turno dividido?</h3>
      </div>
    </b-modal> -->

    <b-modal id="modal-crear" ref="modal-crear" v-model="estadoModalCrear" title="Crear Lote-Válvula" ok-title="Crear"
             cancel-title="Cancelar" cancel-variant="outline-secondary" size="lg" centered :ok-disabled="loadingCrear"
             :cancel-disabled="loadingCrear" no-close-on-esc no-close-on-backdrop @show="" @hidden="resetModal"
             @ok="validacionCrear">
      <div v-if="loadingCrear" align="center">
        <p>Creando ... </p>
        <b-spinner label="Creando..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioCrear" #default="{ invalid }">
        <b-form autocomplete="off" @submit.prevent="crearRegistro">
          <b-row>
            <b-col lg="6">
              <b-form-group label="Empresa" label-for="empresa_e">
                <validation-provider #default="{ errors }" name="Empresa" vid="empresa_e" rules="required">
                  <b-form-input id="empresa_e" v-model="empresa" :state="errors.length > 0 ? false : null"
                                name="empresa_e" disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Fundo" label-for="fundo_e">
                <validation-provider #default="{ errors }" name="Fundo" vid="fundo_e" rules="required">
                  <b-form-input id="fundo_e" v-model="fundo" :state="errors.length > 0 ? false : null" name="fundo_e"
                                disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group label="Etapa" label-for="etapa_e">
                <validation-provider #default="{ errors }" name="Etapa" vid="etapa_e" rules="required">
                  <b-form-input id="etapa_e" v-model="etapa" :state="errors.length > 0 ? false : null" name="etapa_e"
                                disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Campo" label-for="campo_e">
                <validation-provider #default="{ errors }" name="Campo" vid="campo_e" rules="required">
                  <b-form-input id="campo_e" v-model="campo" :state="errors.length > 0 ? false : null" name="campo_e"
                                disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Turno" label-for="turno_e">
                <validation-provider #default="{ errors }" name="Turno" vid="turno_e" rules="required">
                  <b-form-input id="turno_e" v-model="turno" :state="errors.length > 0 ? false : null" name="turno_e"
                                disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group label="Cultivo" label-for="cultivo_e">
                <validation-provider #default="{ errors }" name="Cultivo" vid="cultivo_e" rules="required">
                  <b-form-input id="cultivo_e" v-model="cultivo" :state="errors.length > 0 ? false : null"
                                name="cultivo_e" disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Variedad" label-for="variedad_e">
                <validation-provider #default="{ errors }" name="Variedad" vid="variedad_e" rules="required">
                  <b-form-input id="variedad_e" v-model="variedad" :state="errors.length > 0 ? false : null"
                                name="variedad_e" disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Área Total" label-for="area_total">
                <validation-provider #default="{ errors }" name="Área Total" vid="area_total" rules="required">
                  <b-form-input id="area_total_e" v-model="area_total" :state="errors.length > 0 ? false : null"
                                name="area_total" disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group label="Código Homologado" label-for="cod_homologado_e">
                <validation-provider #default="{ errors }" name="Código Homologado" vid="cod_homologado_e"
                                     rules="required">
                  <b-form-input id="cod_homologado_e" v-model="cod_homologado" :state="errors.length > 0 ? false : null"
                                name="cod_homologado_e" disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Código Homologado N" label-for="cod_homologado_n_e">
                <validation-provider #default="{ errors }" name="Código Homologado N" vid="cod_homologado_n_e"
                                     rules="required">
                  <b-form-input id="cod_homologado_n_e" v-model="cod_homologado_n"
                                :state="errors.length > 0 ? false : null" name="cod_homologado_n_e" disabled/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Estado Uno" label-for="estado_uno_e">
                <validation-provider #default="{ errors }" name="Estado Uno" vid="estado_uno_e" rules="required">
                  <v-select id="estado_uno_e" v-model="estado_uno" :options="estados_uno"
                            :reduce="estados => estados.value"
                            label="text" key="value" placeholder="Seleccionar estado..."/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group label="Lote" label-for="lote_e">
                <validation-provider #default="{ errors }" name="Lote" vid="lote_e" rules="required">
                  <b-form-input id="lote_e" v-model="lote" :state="errors.length > 0 ? false : null" name="lote_e"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Válvula" label-for="valvula_e">
                <validation-provider #default="{ errors }" name="Válvula" vid="valvula_e" rules="required">
                  <b-form-input id="valvula_e" v-model="valvula" :state="errors.length > 0 ? false : null"
                                name="valvula_e"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- <b-col lg="4">
              <b-form-group label="Área Sembrada" label-for="area_sembrada_e">
                <validation-provider #default="{ errors }" name="Área Sembrada" vid="area_sembrada_e" rules="required">
                  <b-form-input id="area_sembrada_e" v-model="area_sembrada" :state="errors.length > 0 ? false : null"
                    name="area_sembrada_e" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <b-col lg="4">
              <b-form-group label="Área Subtotal" label-for="area_subtotal_e">
                <validation-provider #default="{ errors }" name="Área Subtotal" vid="area_subtotal_e" rules="required">
                  <b-form-input id="area_subtotal_e" v-model="area_subtotal" :state="errors.length > 0 ? false : null"
                                name="area_subtotal_e" @input="calcularDiferencia()"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Área Real" label-for="area_real_e">
                <validation-provider #default="{ errors }" name="Área Real" vid="area_real_e" rules="required">
                  <b-form-input id="area_real_e" v-model="area_real" :state="errors.length > 0 ? false : null"
                                name="area_real_e" @input="calcularDiferencia()"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Diferencia" label-for="diferencia_e">
                <validation-provider #default="{ errors }" name="Diferencia" vid="diferencia_e" rules="required">
                  <b-form-input id="diferencia_e" v-model="diferencia" :state="errors.length > 0 ? false : null"
                                name="diferencia_e"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Estado Diferencia" label-for="estado_dif_e">
                <validation-provider #default="{ errors }" name="Estado Diferencia" vid="estado_dif_e" rules="required">
                  <v-select id="estado_dif_e" v-model="estado_dif" :options="estados_dos"
                            :reduce="estados => estados.value"
                            label="text" key="value" placeholder="Seleccionar estado..."/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal
        id="modal-importar"
        ref="modal-importar"
        v-model="estadoModalImportar"
        title="Importar Datos Masivos"
        ok-title="Importar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        size="md"
        :cancel-disabled="loadingIMP"
        :ok-disabled="loadingIMP||!archivo_excel"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        @ok="importarOk"
    >
      <div v-if="loadingIMP" align="center">
        <p>Importando datos ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioImportar" #default="{invalid}">
        <b-form autocomplete="off" @submit.prevent="enviarFile">
          <b-row>
            <b-col lg="12">
              <b-form-group
                  label="Archivo"
                  label-for="archivo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Archivo"
                    vid="archivo"
                    rules="required"
                >
                  <b-form-file
                      id="archivo"
                      accept=".xlsx"
                      placeholder="Seleccionar Archivo Excel (.xlsx)"
                      v-model="archivo_excel"
                      ref="fileinput"
                  >
                    <template
                        slot="file-name"
                        slot-scope="{ names }"
                    >
                      <b-badge variant="primary">
                        {{ names[0] }}
                      </b-badge>
                    </template>
                  </b-form-file>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal
        id="modal-versionar"
        ref="modal-versionar"
        v-model="estadoModalVersionar"
        title="Actualizar version - subversion"
        ok-title="Versionar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        size="md"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        @ok="versionarOk"
    >
      <div v-if="loadingEditar" align="center">
        <p>Editando ... </p>
        <b-spinner label="Editando..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioEditar" #default="{ invalid }">
        <b-form autocomplete="off" @submit.prevent="traerLotesValvulas">
          <b-row>
            <b-col lg="12">
              <b-form-group
                  label="Version"
                  label-for="version"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Version"
                    vid="version"
                    rules="required"
                >
                  <v-select
                      id="version"
                      v-model="version_elegida"
                      :options="lista_versiones"
                      placeholder="Seleccionar version..."
                      @input="filtrarSubversiones"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="12">
              <b-form-group
                  label="Subversion"
                  label-for="subversion"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Subversion"
                    vid="subversion"
                    rules="required"
                >
                  <v-select
                      id="subversion"
                      v-model="subversion_elegida"
                      :options="lista_subversiones"
                      placeholder="Seleccionar subversion..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

  </div>
</template>

<script>

import axiosIns from '../../../libs/axios'
import vSelect from 'vue-select'

import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BModal,
  BFormFile,
  BPagination,
  BSpinner,
  BTable,
  BRow,
  BCol,
  BDropdownDivider,
  BInputGroup, BInputGroupAppend, BTooltip,
  BFormCheckbox,
  BDropdown, BDropdownForm, BDropdownItem, BDropdownHeader,
  VBTooltip
} from 'bootstrap-vue'
import {heightTransition} from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import {ValidationProvider, ValidationObserver, localize} from 'vee-validate'
import {required} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BFormInput,
    BModal,
    BFormFile,
    BForm,
    BCol,
    BRow,
    BDropdownDivider,
    BInputGroup,
    BInputGroupAppend,
    BTooltip,
    BFormCheckbox,
    BDropdown, BDropdownForm, BDropdownItem, BDropdownHeader,

    vSelect,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mixins: [heightTransition],
  data: () => ({
    id_user: JSON.parse(localStorage.getItem('userData')).id,
    nombre_usuario_activo: JSON.parse(localStorage.getItem('userData')).fullName,
    semana: '23',
    cultivo: null,
    empresa: null,
    fundo: null,
    etapa: null,
    campo: null,
    turno: null,
    variedad: null,
    turnoid: null,
    lote: null,
    valvula: null,
    area_total: null,
    area_subtotal: null,
    lotes_valvulas_encontrados: [], //Almacena los que se buscaron por cod_homologado
    estadoModalImportar: false,
    total_lotes_valvulas: [], //Almacena TODOS los lotes y valvulas que se traen por la version y subversion elegida
    loadingIMP: false,
    archivo_excel: null,
    lotes_activos: [],
    valvulas_activas: [],
    area_sembrada: null,
    diferencia: null,
    estado_dif: null,
    area_real: null,
    cod_homologado: null,
    cod_homologado_n: null,
    codigo: null,
    producto: null,
    grupo: null,
    uni_med: null,
    lista_vers_subvers: [],
    lista_versiones: [],
    lista_subversiones: [],
    estado_uno: null,
    estado_dos: null,
    version_elegida: null,
    subversion_elegida: null,
    ultima_version: null,
    ultima_subversion: null,
    itemsResumen: [],
    dias: null,
    kg_ha_dia: null,
    total_max_dia: "0.0",

    lunes: "0.0",
    martes: "0.0",
    miercoles: "0.0",
    jueves: "0.0",
    viernes: "0.0",
    sabado: "0.0",
    domingo: "0.0",

    indicador: "0.0",
    ulti_grupo_desp: null,
    submittedNames: [],
    loading: false,
    loadingDividir: false,
    loadingEditar: false,
    loadingCrear: false,
    loadingUnir: false,
    loadingExp: false,
    items: [],
    perPage: 10,
    pageOptions: [10, 15, 20],
    totalRows: 0,
    currentPage: 1,
    sortBy: 'cod_homologado',
    sortDesc: false,
    sortDirection: 'asc',
    filter: null,
    cod_homo_unicos: [],
    filterOn: ['cod_homologado'],
    // fields: [
    //   {
    //     key: 'show_details',
    //     label: 'Detalle',
    //     thClass: 'py-0 alinear-medio',
    //     class: 'text-center',
    //     stickyColumn: true
    //   },
    //   {
    //     key: 'sociedad',
    //     label: 'Sociedad',
    //     sortable: true,
    //     tdClass: 'alinear-una-sola-linea',
    //     thClass: 'py-0 alinear-medio',
    //   },
    //   {
    //     key: 'fundo',
    //     label: 'fundo',
    //     sortable: true,
    //     tdClass: 'alinear-una-sola-linea',
    //     thClass: 'py-0 alinear-medio',
    //   },
    //   {
    //     key: 'etapa',
    //     label: 'etapa',
    //     sortable: true,
    //     tdClass: 'alinear-una-sola-linea',
    //     thClass: 'py-0 alinear-medio',
    //   },
    //   {
    //     key: 'campo',
    //     label: 'campo',
    //     sortable: true,
    //     tdClass: 'alinear-una-sola-linea',
    //     thClass: 'py-0 alinear-medio',
    //   },
    //   {
    //     key: 'turno',
    //     label: 'turno',
    //     sortable: true,
    //     tdClass: 'alinear-una-sola-linea',
    //     thClass: 'py-0 alinear-medio',
    //   },
    //   {
    //     key: 'cultivo',
    //     label: 'cultivo',
    //     sortable: true,
    //     tdClass: 'alinear-una-sola-linea',
    //     thClass: 'py-0 alinear-medio',
    //   },
    //   {
    //     key: 'variedad',
    //     label: 'variedad',
    //     sortable: true,
    //     tdClass: 'alinear-una-sola-linea',
    //     thClass: 'py-0 alinear-medio',
    //   },
    //   {
    //     key: 'area_total',
    //     label: 'área total',
    //     sortable: true,
    //     tdClass: 'alinear-una-sola-linea',
    //     thClass: 'py-0 alinear-medio',
    //   },
    //   {
    //     key: 'cod_homologado',
    //     label: 'Código homologado G.',
    //     sortable: true,
    //     tdClass: 'alinear-una-sola-linea',
    //     thClass: 'alinear-una-sola-linea alinear-medio',
    //   },
    // ],

    fields: [
      {
        key: 'show_details',
        label: 'Detalle',
        thClass: 'py-0 alinear-medio',
        class: 'text-center',
        stickyColumn: true
      },
      {
        key: 'estado_resumen',
        label: 'Estado',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'alinear-una-sola-linea alinear-medio',
        formatter(value, key, item) {
          return item.estado_resumen + (item.observacion ? ' ' + item.observacion : '');
        }
      },
      // {
      //   key: 'cod_homologado',
      //   label: 'Código homologado G.',
      //   sortable: true,
      //   tdClass: 'alinear-una-sola-linea',
      //   thClass: 'alinear-una-sola-linea alinear-medio',
      // },
      {
        key: 'cod_homologado_turno',
        label: 'Código homologado G.',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'alinear-una-sola-linea alinear-medio',
      },
      {
        key: 'sociedad',
        label: 'Sociedad',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'cultivo',
        label: 'cultivo',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'fundo',
        label: 'fundo',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'etapa',
        label: 'etapa',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'campo',
        label: 'campo',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'turno',
        label: 'turno',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'variedad',
        label: 'variedad',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'lote',
        label: 'lotes',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'valvula',
        label: 'valvulas',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      // {
      //   key: 'area_total',
      //   label: 'área total',
      //   sortable: true,
      //   tdClass: 'alinear-una-sola-linea',
      //   thClass: 'py-0 alinear-medio',
      // },
      {
        key: 'area_ha',
        label: 'área total',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'area_real',
        label: 'área real',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
        formatter: (value, key, item) => {
          // Redondea el valor a tres decimales antes de mostrarlo
          return parseFloat(value).toFixed(3);
        },
      },

    ],

    fields2: [
      {
        key: 'acciones',
        label: '# ',
        thClass: 'py-0 alinear-medio text-center',
        class: 'text-center text-center',
        stickyColumn: true
      },
      {
        key: 'estado_uno_texto',
        label: 'estado_uno',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-center',
        thClass: 'py-0 alinear-medio text-center',
        formatter(value, key, item) {
          return item.estado_uno_texto + (item.observacion ? ' ' + item.observacion : '');
        }
      },
      {
        key: 'lote',
        label: 'lote',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-center',
        thClass: 'py-0 alinear-medio text-center',
      },
      {
        key: 'valvula',
        label: 'válvula',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-center',
        thClass: 'py-0 alinear-medio text-center',
      },
      {
        key: 'cod_homologado',
        label: 'Código homologado',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-center',
        thClass: 'py-0 alinear-medio text-center',
      },
      {
        key: 'area_subtotal',
        label: 'área subtotal',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-center',
        thClass: 'py-0 alinear-medio text-center',
      },
      {
        key: 'area_real',
        label: 'area_real',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-center',
        thClass: 'py-0 alinear-medio text-center',
      },
      {
        key: 'diferencia',
        label: 'diferencia',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-center',
        thClass: 'py-0 alinear-medio text-center',
      },
      {
        key: 'estado_dos_texto',
        label: 'estado_dos',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-center',
        thClass: 'py-0 alinear-medio text-center',
      },
      {
        key: 'responsable',
        label: 'responsable',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
      {
        key: 'modified',
        label: 'ultima modificacion',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
        thClass: 'py-0 alinear-medio',
      },
    ],
    status_turno: [
      {
        4: 'Activo',
      },
      {
        4: 'light-success',
      }
    ],

    status_lotevalvula: [
      {
        0: 'Activo',
      },
      {
        0: 'light-success',
      }
    ],
    // status: [
    //   {
    //     0: 'Activo',
    //     1: 'Siembra',
    //     2: 'Inactivo',
    //     3: 'Eliminado',
    //   },
    //   {
    //     0: 'light-success',
    //     1: 'light-warning',
    //     2: 'light-danger',
    //     3: 'light-dark',
    //   }
    // ],

    // estados: [
    //   { value: '0', text: "Activo" },
    //   { value: '1', text: "Agrupado" },
    //   { value: '2', text: "Inactivo" },
    //   { value: '3', text: "Eliminado" },
    // ],

    // estados_dos: [
    //   { value: '0', text: "Pendiente" },
    //   { value: '1', text: "Area Libre" },
    //   { value: '2', text: "Inactivo" },
    //   { value: '3', text: "Eliminado" },
    // ],

    estados: [
      {value: '0', text: "ACTIVO"},
      {value: '1', text: "AGRUPADO"},
      {value: '2', text: "INACTIVO"},
      {value: '3', text: "ELIMINADO"},
    ],

    estados_uno: [
      {value: '0', text: "ACTIVO"},
      {value: '2', text: "INACTIVO"},
    ],

    estados_dos: [
      {value: '0', text: "PENDIENTE"},
      {value: '1', text: "AREA LIBRE"},
      {value: '2', text: "INACTIVO"},
      {value: '3', text: "ELIMINADO"},
    ],

    // estados: [
    //   { value: '0', text: "Activo" },
    //   { value: '1', text: "Siembra" },
    //   { value: '2', text: "Inactivo" },
    //   { value: '3', text: "Eliminado" },
    // ],

    estado_aprobar: null,
    estadoModalDividir: false,
    estadoModalUnir: false,
    estadoModalCrear: false,

    empresas: [
      'AGROVISIÓN PERÚ S.A.C',
      'ARENA VERDE'
    ],
    semanas: ['23'],
    cultivos: [
      'ARÁNDANO',
      'ESPÁRRAGO',
      'PALTA',
      'UVA'
    ],
    fundos: [
      'OLMOS A9',
      'OLMOS C5',
      'OLMOS C6'
    ],
    etapas: [
      'ETAPA 1',
      'ETAPA 2',
      'ETAPA 3'
    ],
    campos: [
      'CAMPO 3',
      'CAMPO 4',
      'CAMPO 5',
      'CAMPO 7',
    ],
    turnos: [
      'TURNO 1-A',
      'TURNO 2-A',
      'TURNO 3-A',
      'TURNO 4-A',
      'TURNO 5-A',
      'TURNO 5-B',
      'TURNO 5-C',
      'TURNO 5-D',
    ],

    estadoModalEditar: false,
    estadoModalVersionar: false,
    empresa1: null,
    fundo1: null,
    etapa1: null,
    campo1: null,
    turno1: null,
    lote1: null,
    valvula1: null,
    cultivo1: null,
    variedad1: null,
    cod_homologado1: null,
    area_total1: null,
    area_sembrada1: null,

    empresa2: null,
    fundo2: null,
    etapa2: null,
    campo2: null,
    turno2: null,
    lote2: null,
    valvula2: null,
    cultivo2: null,
    variedad2: null,
    cod_homologado2: null,
    area_total2: null,
    area_sembrada2: null,

    id_duplicado: null,
    id_unir: null,

    items_repeat: [],
    nextTodoId: 7,
    itemsFiltro: [],
    mostrar: false,

    multiple: false,
    id_editar: null,

    lote_c: [],
    valvula_c: null,
    isAgrup: false,
    area_subtotal_c: null,
    area_real_c: null,
    area_sembrada_c: null,
    cod_homologado_c: null,
    diferencia_c: null,
    estadoCorrelativo: false,
    deshabilitar: false,

    itemsVista: [],
    filtro: [
      {nombre: "sociedad", valor: []},
      {nombre: "fundo", valor: []},
      {nombre: "cultivo", valor: []},
      {nombre: "etapa", valor: []},
      {nombre: "campo", valor: []},
      {nombre: "variedad", valor: []},
      {nombre: "turno", valor: []}
    ],
    sociedadFiltro: [],
    fundoFiltro: [],
    cultivoFiltro: [],
    etapaFiltro: [],
    campoFiltro: [],
    variedadFiltro: [],
    turnoFiltro: [],

    sociedad_filtro: [],
    fundo_filtro: [],
    cultivo_filtro: [],
    etapa_filtro: [],
    campo_filtro: [],
    variedad_filtro: [],
    turno_filtro: [],


    // validation rules
    required,
  }),
  computed: {},
  mounted() {
    this.initTrHeight();
    this.traerLotesValvulas();
    this.traerVersionesSubversiones();
    localize("es");
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {

    // traerLotes() {
    //   const yo = this
    //   yo.loading = true

    //   const data = JSON.stringify(
    //     {
    //       'version_elegida': yo.version_elegida,
    //       'subversion_elegida': yo.subversion_elegida
    //     }
    //   )

    //   const config = {
    //     method: 'post',
    //     // url: '/lotes/' //Anteriormente consultabamos primero a pag_lotes_valvulas, ahora es primero la data de pcgagro para que me traiga los turnos, luegos que doy click en 1 de ellos recien me muestra el detalle
    //     url: '/turnos_por_version/', //Esto cuando traía los turnos primero, pero luego de reunion con Jeyson se trae primero los lotes_valvulas
    //     data: data
    //   }

    //   axiosIns(config)
    //     .then(function (response) {
    //       if (response.status === 200) {

    //         yo.items = response.data['data']
    //         yo.itemsFiltro = response.data['data']

    //         // yo.itemsFiltro = response.data['data_filtrada']
    //         // yo.itemsVista = yo.itemsFiltro.sort((a, b) => {
    //         //   if (a.cod_homologado < b.cod_homologado) {
    //         //     return -1;
    //         //   }
    //         //   if (a.cod_homologado > b.cod_homologado) {
    //         //     return 1;
    //         //   }

    //         //   return 0;
    //         // })

    //         // console.log(yo.itemsVista)

    //         yo.sociedadFiltro = []
    //         yo.fundoFiltro = []
    //         yo.cultivoFiltro = []
    //         yo.etapaFiltro = []
    //         yo.campoFiltro = []
    //         yo.variedadFiltro = []
    //         yo.turnoFiltro = []

    //         for (let value of yo.itemsFiltro) {
    //           if (value.sociedad !== null && value.sociedad !== '' && value.sociedad !== ' ' && value.sociedad !== '  ') { yo.sociedadFiltro.push(value.sociedad) }
    //           if (value.fundo !== null && value.fundo !== '' && value.fundo !== ' ' && value.fundo !== '  ') { yo.fundoFiltro.push(value.fundo) }
    //           if (value.cultivo !== null && value.cultivo !== '' && value.cultivo !== ' ' && value.cultivo !== '  ') { yo.cultivoFiltro.push(value.cultivo) }
    //           if (value.etapa !== null && value.etapa !== '' && value.etapa !== ' ' && value.etapa !== '  ') { yo.etapaFiltro.push(value.etapa) }
    //           if (value.campo !== null && value.campo !== '' && value.campo !== ' ' && value.campo !== '  ') { yo.campoFiltro.push(value.campo) }
    //           if (value.variedad !== null && value.variedad !== '' && value.variedad !== ' ' && value.variedad !== '  ') { yo.variedadFiltro.push(value.variedad) }
    //           if (value.turno !== null && value.turno !== '' && value.turno !== ' ' && value.turno !== '  ') { yo.turnoFiltro.push(value.turno) }
    //         }

    //         yo.sociedadFiltro = [...new Set(yo.sociedadFiltro)].sort()
    //         yo.fundoFiltro = [...new Set(yo.fundoFiltro)].sort()
    //         yo.cultivoFiltro = [...new Set(yo.cultivoFiltro)].sort()
    //         yo.etapaFiltro = [...new Set(yo.etapaFiltro)].sort()
    //         yo.campoFiltro = [...new Set(yo.campoFiltro)].sort()
    //         yo.variedadFiltro = [...new Set(yo.variedadFiltro)].sort()
    //         yo.turnoFiltro = [...new Set(yo.turnoFiltro)].sort()

    //         // yo.sociedadFiltro.push('VACIOS')
    //         // yo.fundoFiltro.push('VACIOS')
    //         // yo.cultivoFiltro.push('VACIOS')
    //         // yo.etapaFiltro.push('VACIOS')
    //         // yo.campoFiltro.push('VACIOS')
    //         // yo.variedadFiltro.push('VACIOS')
    //         // yo.turnoFiltro.push('VACIOS')
    //       }
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     })
    //     .finally(function () {
    //       yo.loading = false
    //       yo.realizarFiltro('', [])
    //     })
    // },


    filtrarPorBusqueda(accion) {
      const yo = this
      let busqueda = yo.filter
      // console.log(yo.filter)

      if (accion === false) {
        yo.filter = ''
        yo.itemsFiltro = yo.itemsResumen
      } else {
        let resultadoFiltro = []
        resultadoFiltro = yo.itemsFiltro.filter(item =>
            // item.cod_homologado.includes(busqueda)
            item.cod_homologado_turno.includes(busqueda)
        );
        yo.itemsFiltro = resultadoFiltro
        // console.log(yo.itemsFiltro)
      }
    },

    traerVersionesSubversiones() {
      const yo = this
      const config = {
        method: 'post',
        url: 'pagricolas/turnos/consultar_versiones_subversiones/',
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              // console.log(response.data['data'])
              let lista_vers_subvers = response.data['data']
              yo.lista_vers_subvers = lista_vers_subvers
              if (lista_vers_subvers.length > 0) {
                let lista_vers = []
                for (let x of yo.lista_vers_subvers) {
                  if (!lista_vers.includes(x['name'])) {
                    // console.log(x['name']);
                    lista_vers.push(x['name']);
                  }
                }
                yo.lista_versiones = lista_vers
                //Se asigna la posicion 0 a las ver y sub porque se asume que el primero siempre va a ser la version con la
                //que se hizo el desarrollo en un inicio, la primera de todas la version
                yo.version_elegida = lista_vers_subvers[0]['name']
                yo.filtrarSubversiones()
                yo.subversion_elegida = lista_vers_subvers[0]['sub_version']

                yo.ultima_version = lista_vers_subvers[0]['name']
                yo.ultima_subversion = lista_vers_subvers[0]['sub_version']
                yo.traerLotesValvulas()
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {

          })
    },

    traerLotesValvulas() {
      const yo = this
      const data = JSON.stringify(
          {
            'version_elegida': yo.version_elegida,
            'subversion_elegida': yo.subversion_elegida
          }
      )
      // console.log(data)
      // console.log("JK")
      const config = {
        method: 'post',
        url: '/pagricolas/lotes/obtenerLotesValvulasDetallado/',
        data: data
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              // console.log(response.data['data'])

              yo.items = response.data['data'] //Almacena todo el detallado de lotes y valvulas
              yo.cod_homo_unicos = response.data['cod_unicos']

              let total_lotes_valvulas = response.data['data']
              let cod_homo_unicos = response.data['cod_unicos']
              let resumen_lotes_valvulas = [] //Almacenara los datos que se mostraran primero

              let turnos_vacios_sinlotesval = []

              for (let c of cod_homo_unicos) {
                // console.log(c)
                let resultadosFiltrados = []
                //Del total filtro solo los que cumplen con el cod_homologado
                resultadosFiltrados = total_lotes_valvulas.filter(function (item) {
                  return item.cod_homologado_turno === c;
                });

                if (resultadosFiltrados.length > 0) {
                  // Recorro lo filtrado para volverle a pasar un segundo filtros entre Activos, Pendientes y Agrupados
                  let lista_activos = []
                  let lista_pendientes = []
                  let lista_agrupados = []
                  let lista_final = [] //Almacen el resumen por grupo segun el cod_homologado

                  for (let x of resultadosFiltrados) {
                    //Activos
                    if (x['estado_uno'] === '0') { // 0 es Activo
                      lista_activos.push(x)
                    }
                    //Pendientes
                    if (x['estado_dos'] === '0') {
                      lista_pendientes.push(x)
                    }

                    // if(x['cod_homologado_turno'] == 'ARV-LN-E02C01-T02A'){
                    //   console.log(x)
                    // }
                    //Agrupados
                    if (x['estado_uno'] === '1') {
                      lista_agrupados.push(x)
                    }

                    if (x['lote'] == null || x['lote'] === '') {
                      turnos_vacios_sinlotesval.push(x)
                    }
                  }


                  if (lista_activos.length > 0) {
                    // Ahora trabajo la lista_final_activos
                    let lista_final_activos = []
                    let acumulador_activos = {
                      estado_uno: 0,
                      lote: [],
                      valvula: [],
                      area_subtotal: 0,
                      area_real: 0,
                      diferencia: 0,
                      estado_dos: 0,
                      cod_homologado: '',
                      estado_resumen: '',
                      area_total: '',

                      responsable: '',
                      ult_mod: '',
                    }

                    let ultima_modificacion_a = null;
                    let responsable_ultima_modificacion_a = null;

                    // ----Recorrer lista_activos y acumular valores
                    lista_activos.forEach(function (item) {
                      acumulador_activos.lote += item.lote + ",";
                      acumulador_activos.valvula += item.valvula + ",";
                      acumulador_activos.area_subtotal += item.area_subtotal;
                      acumulador_activos.area_real += item.area_real;
                      acumulador_activos.diferencia += item.diferencia;
                      acumulador_activos.cod_homologado = item.cod_homologado;
                      acumulador_activos.cod_homologado_turno = item.cod_homologado_turno;
                      acumulador_activos.estado_uno_texto = item.estado_uno_texto;
                      acumulador_activos.estado_dos_texto = item.estado_dos_texto;
                      acumulador_activos.sociedad = item.sociedad;
                      acumulador_activos.cultivo = item.cultivo;
                      acumulador_activos.fundo = item.fundo;
                      acumulador_activos.etapa = item.etapa;
                      acumulador_activos.campo = item.campo;
                      acumulador_activos.turno = item.turno;
                      acumulador_activos.variedad = item.variedad;
                      acumulador_activos.estado_resumen = item.estado_uno_texto;
                      // acumulador_activos.area_total = item.area_ha;
                      acumulador_activos.area_ha = item.area_ha;
                      // acumulador_activos.id = item.turno_id;
                      acumulador_activos.id_turno = item.id_turno;

                      acumulador_activos.responsable = item.responsable;
                      acumulador_activos.ult_mod = item.modified;

                      // Verificar si esta es la última modificación
                      // if (!ultima_modificacion_a || new Date(item.modified) > new Date(ultima_modificacion_a)) {
                      //   ultima_modificacion_a = item.modified;
                      //   responsable_ultima_modificacion_a = item.responsable;
                      // }

                    })

                    // ----Eliminar la última coma de las cadenas de lote y valvula
                    acumulador_activos.lote = acumulador_activos.lote.slice(0, -1);
                    acumulador_activos.valvula = acumulador_activos.valvula.slice(0, -1);

                    // Establecer el responsable y la última modificación en el acumulador
                    // acumulador_activos.responsable = responsable_ultima_modificacion_a;
                    // acumulador_activos.ult_mod = ultima_modificacion_a;

                    // ----Agregar el acumulador a lista_final_activos
                    lista_final_activos.push(acumulador_activos);
                    resumen_lotes_valvulas.push(acumulador_activos)
                  }

                  if (lista_pendientes.length > 0) {
                    // Ahora trabajo la lista_final_pendientes
                    let lista_final_pendientes = []
                    let acumulador_pendientes = {
                      estado_uno: 0,
                      lote: [],
                      valvula: [],
                      area_subtotal: 0,
                      area_real: 0,
                      diferencia: 0,
                      estado_dos: 0,
                      cod_homologado: '',
                      estado_resumen: '',
                      area_total: '',

                      responsable: '',
                      ult_mod: '',
                    }

                    let ultima_modificacion_p = null;
                    let responsable_ultima_modificacion_p = null;

                    lista_pendientes.forEach(function (item) {
                      acumulador_pendientes.lote += item.lote + ",";
                      acumulador_pendientes.valvula += item.valvula + ",";
                      acumulador_pendientes.area_subtotal += item.area_subtotal;
                      // acumulador_pendientes.area_real += item.area_real;
                      acumulador_pendientes.area_real += item.diferencia; //Cuando solo son pendientes el area_real debe ser la sumatoria de la diferencia
                      acumulador_pendientes.diferencia += item.diferencia;
                      acumulador_pendientes.cod_homologado = item.cod_homologado;
                      acumulador_pendientes.cod_homologado_turno = item.cod_homologado_turno;
                      acumulador_pendientes.estado_uno_texto = item.estado_uno_texto;
                      acumulador_pendientes.estado_dos_texto = item.estado_dos_texto;
                      acumulador_pendientes.sociedad = item.sociedad;
                      acumulador_pendientes.cultivo = item.cultivo;
                      acumulador_pendientes.fundo = item.fundo;
                      acumulador_pendientes.etapa = item.etapa;
                      acumulador_pendientes.campo = item.campo;
                      acumulador_pendientes.turno = item.turno;
                      acumulador_pendientes.variedad = item.variedad;
                      acumulador_pendientes.estado_resumen = item.estado_dos_texto;
                      // acumulador_pendientes.area_total = item.area_ha;
                      acumulador_pendientes.area_ha = item.area_ha;
                      // acumulador_pendientes.id = item.turno_id;
                      acumulador_pendientes.id_turno = item.id_turno;

                      acumulador_pendientes.responsable = item.responsable;
                      acumulador_pendientes.ult_mod = item.modified;

                      // Verificar si esta es la última modificación
                      // if (!ultima_modificacion_p || new Date(item.modified) > new Date(ultima_modificacion_p)) {
                      //     ultima_modificacion_p = item.modified;
                      //     responsable_ultima_modificacion_p = item.responsable;
                      // }

                    })

                    // ----Eliminar la última coma de las cadenas de lote y valvula
                    acumulador_pendientes.lote = acumulador_pendientes.lote.slice(0, -1);
                    acumulador_pendientes.valvula = acumulador_pendientes.valvula.slice(0, -1);

                    // Establecer el responsable y la última modificación en el acumulador
                    // acumulador_pendientes.responsable = responsable_ultima_modificacion_p;
                    // acumulador_pendientes.ult_mod = ultima_modificacion_p;

                    // ----Agregar el acumulador a lista_final_activos
                    lista_final_pendientes.push(acumulador_pendientes);

                    for (let y of lista_final_pendientes) {
                      if (y['estado_dos'] === '0') {
                        y['estado_uno_texto'] = 'PENDIENTE'
                      }
                    }
                    resumen_lotes_valvulas.push(acumulador_pendientes)
                  }

                  //Ahora construyo la lista final que presentaré:
                  // lista_final.push(acumulador_activos)
                  // lista_final.push(acumulador_pendientes)

                  let ultima_modificacion_ag = null;
                  let responsable_ultima_modificacion_ag = null;

                  for (let z of lista_agrupados) {
                    // if(z['cod_homologado'] == 'AGV-C5-E01C01-T01B' ){
                    //   console.log(z)
                    // }
                    // if(z['observacion']){
                    //   z['estado_resumen'] = 'AGRUPADO' + ' ' + z['observacion']
                    // }else{
                    //   z['estado_resumen'] = 'AGRUPADO'
                    // }
                    z['estado_resumen'] = 'AGRUPADO'
                    z['area_total'] = z['area_ha']
                    resumen_lotes_valvulas.push(z)
                    // if(z['cod_homologado'] == 'AGV-C5-E01C01-T01B' ){
                    //   console.log(z)
                    // }
                  }
                }

              }

              // console.log("H")

              // resumen_lotes_valvulas = resumen_lotes_valvulas.concat(turnos_vacios_sinlotesval)

              // console.log(turnos_vacios_sinlotesval)
              // //
              // let uniqueItems = {};
              // let filteredItems = resumen_lotes_valvulas.filter(item => {
              //     //// Creamos una clave única que incluya todos los campos relevantes
              //     //// let key = `${item.cod_homologado_turno || 'null'}-${item.lote || 'null'}-${item.valvula || 'null'}-${item.area_ha || 'null'}-${item.cultivo || 'null'}-${item.sociedad || 'null'}`;
              //     let key = `${item.cod_homologado_turno || 'null'}-${item.cultivo || 'null'}-${item.etapa || 'null'}-${item.fundo || 'null'}-${item.sociedad || 'null'}-${item.turno || 'null'}-${item.variedad || 'null'}-${item.estado_uno_texto || 'null'}-${item.estado_dos_texto || 'null'}`;
              //     //// Si la clave no está en uniqueItems, la agregamos y mantenemos el elemento
              //     if (!uniqueItems[key]) {
              //         uniqueItems[key] = true;
              //         return true;
              //     }
              //     // Si la clave ya existe, descartamos el elemento
              //     return false;
              // });
              //

              for (let i = 0; i < turnos_vacios_sinlotesval.length; i++) {
                let item = turnos_vacios_sinlotesval[i];
                let exists = resumen_lotes_valvulas.some(existingItem => existingItem.cod_homologado_turno === item.cod_homologado_turno);

                if (!exists) {
                  resumen_lotes_valvulas.push(item);
                }
              }

              let uniqueItems = {};
              let filteredItems = resumen_lotes_valvulas.filter(item => {
                // let key = `${item.cod_homologado_turno || 'null'}-${item.cultivo || 'null'}-${item.etapa || 'null'}-${item.fundo || 'null'}-${item.sociedad || 'null'}-${item.turno || 'null'}-${item.variedad || 'null'}-${item.estado_uno_texto || 'null'}-${item.estado_dos_texto || 'null'}`;
                let key = `${item.cod_homologado_turno || 'null'}-${item.cultivo || 'null'}-${item.etapa || 'null'}-${item.fundo || 'null'}-${item.sociedad || 'null'}-${item.turno || 'null'}-${item.variedad || 'null'}-${item.estado_uno_texto || 'null'}-${item.estado_dos_texto || 'null'}-${item.observacion || 'null'}`;

                if (!uniqueItems[key]) {
                  uniqueItems[key] = true;
                  return true;
                }

                return false;
              });

              yo.itemsFiltro = filteredItems;
              // yo.itemsFiltro.sort((a, b) => a.cod_homologado.localeCompare(b.cod_homologado));
              yo.itemsResumen = yo.itemsFiltro
              //Ordeno
              // console.log("FINALITO")
              // for(let j of yo.itemsFiltro){
              //   if(j['cod_homologado'] == 'AGV-C5-E01C01-T01B' && j['estado_uno'] == '1' ){
              //     console.log(j)
              //   }
              // }

              //Llenando los filtros
              yo.sociedadFiltro = []
              yo.fundoFiltro = []
              yo.cultivoFiltro = []
              yo.etapaFiltro = []
              yo.campoFiltro = []
              yo.variedadFiltro = []
              yo.turnoFiltro = []

              for (let value of yo.itemsFiltro) {
                if (value.sociedad !== null && value.sociedad !== '' && value.sociedad !== ' ' && value.sociedad !== '  ') {
                  yo.sociedadFiltro.push(value.sociedad)
                }
                if (value.fundo !== null && value.fundo !== '' && value.fundo !== ' ' && value.fundo !== '  ') {
                  yo.fundoFiltro.push(value.fundo)
                }
                if (value.cultivo !== null && value.cultivo !== '' && value.cultivo !== ' ' && value.cultivo !== '  ') {
                  yo.cultivoFiltro.push(value.cultivo)
                }
                if (value.etapa !== null && value.etapa !== '' && value.etapa !== ' ' && value.etapa !== '  ') {
                  yo.etapaFiltro.push(value.etapa)
                }
                if (value.campo !== null && value.campo !== '' && value.campo !== ' ' && value.campo !== '  ') {
                  yo.campoFiltro.push(value.campo)
                }
                if (value.variedad !== null && value.variedad !== '' && value.variedad !== ' ' && value.variedad !== '  ') {
                  yo.variedadFiltro.push(value.variedad)
                }
                if (value.turno !== null && value.turno !== '' && value.turno !== ' ' && value.turno !== '  ') {
                  yo.turnoFiltro.push(value.turno)
                }
              }

              yo.sociedadFiltro = [...new Set(yo.sociedadFiltro)].sort()
              yo.fundoFiltro = [...new Set(yo.fundoFiltro)].sort()
              yo.cultivoFiltro = [...new Set(yo.cultivoFiltro)].sort()
              yo.etapaFiltro = [...new Set(yo.etapaFiltro)].sort()
              yo.campoFiltro = [...new Set(yo.campoFiltro)].sort()
              yo.variedadFiltro = [...new Set(yo.variedadFiltro)].sort()
              yo.turnoFiltro = [...new Set(yo.turnoFiltro)].sort()


            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {

          })

    },

    armarDataGeneral() {

      const yo = this

      console.log("HOLA")
      console.log(yo.items.length)
      let total_lotes_valvulas = yo.items
      let cod_homo_unicos = yo.cod_homo_unicos
      let resumen_lotes_valvulas = [] //Almacenara los datos que se mostraran primero

      let turnos_vacios_sinlotesval = []

      for (let c of cod_homo_unicos) {
        // console.log(c)
        let resultadosFiltrados = []
        //Del total filtro solo los que cumplen con el cod_homologado
        resultadosFiltrados = total_lotes_valvulas.filter(function (item) {
          return item.cod_homologado_turno === c;
        });

        if (resultadosFiltrados.length > 0) {
          // Recorro lo filtrado para volverle a pasar un segundo filtros entre Activos, Pendientes y Agrupados
          let lista_activos = []
          let lista_pendientes = []
          let lista_agrupados = []
          let lista_final = [] //Almacen el resumen por grupo segun el cod_homologado

          for (let x of resultadosFiltrados) {
            //Activos
            if (x['estado_uno'] === '0') { // 0  es Activo
              lista_activos.push(x)
            }
            //Pendientes
            if (x['estado_dos'] === '0') {
              lista_pendientes.push(x)
            }

            if (x['cod_homologado_turno'] === 'ARV-LN-E02C01-T02A') {
              console.log(x)
            }
            //Agrupados
            if (x['estado_uno'] === '1') {
              lista_agrupados.push(x)
            }

            if (x['lote'] == null || x['lote'] === '') {
              turnos_vacios_sinlotesval.push(x)
            }
          }


          if (lista_activos.length > 0) {
            // Ahora trabajo la lista_final_activos
            let lista_final_activos = []
            let acumulador_activos = {
              estado_uno: 0,
              lote: [],
              valvula: [],
              area_subtotal: 0,
              area_real: 0,
              diferencia: 0,
              estado_dos: 0,
              cod_homologado: '',
              estado_resumen: '',
              area_total: '',

              responsable: '',
              ult_mod: '',
            }

            let ultima_modificacion_a = null;
            let responsable_ultima_modificacion_a = null;

            // ----Recorrer lista_activos y acumular valores
            lista_activos.forEach(function (item) {
              acumulador_activos.lote += item.lote + ",";
              acumulador_activos.valvula += item.valvula + ",";
              acumulador_activos.area_subtotal += item.area_subtotal;
              acumulador_activos.area_real += item.area_real;
              acumulador_activos.diferencia += item.diferencia;
              acumulador_activos.cod_homologado = item.cod_homologado;
              acumulador_activos.cod_homologado_turno = item.cod_homologado_turno;
              acumulador_activos.estado_uno_texto = item.estado_uno_texto;
              acumulador_activos.estado_dos_texto = item.estado_dos_texto;
              acumulador_activos.sociedad = item.sociedad;
              acumulador_activos.cultivo = item.cultivo;
              acumulador_activos.fundo = item.fundo;
              acumulador_activos.etapa = item.etapa;
              acumulador_activos.campo = item.campo;
              acumulador_activos.turno = item.turno;
              acumulador_activos.variedad = item.variedad;
              acumulador_activos.estado_resumen = item.estado_uno_texto;
              // acumulador_activos.area_total = item.area_ha;
              acumulador_activos.area_ha = item.area_ha;
              // acumulador_activos.id = item.turno_id;
              acumulador_activos.id_turno = item.id_turno;

              acumulador_activos.responsable = item.responsable;
              acumulador_activos.ult_mod = item.modified;

              // Verificar si esta es la última modificación
              // if (!ultima_modificacion_a || new Date(item.modified) > new Date(ultima_modificacion_a)) {
              //   ultima_modificacion_a = item.modified;
              //   responsable_ultima_modificacion_a = item.responsable;
              // }

            })

            // ----Eliminar la última coma de las cadenas de lote y valvula
            acumulador_activos.lote = acumulador_activos.lote.slice(0, -1);
            acumulador_activos.valvula = acumulador_activos.valvula.slice(0, -1);

            // Establecer el responsable y la última modificación en el acumulador
            // acumulador_activos.responsable = responsable_ultima_modificacion_a;
            // acumulador_activos.ult_mod = ultima_modificacion_a;

            // ----Agregar el acumulador a lista_final_activos
            lista_final_activos.push(acumulador_activos);
            resumen_lotes_valvulas.push(acumulador_activos)
          }

          if (lista_pendientes.length > 0) {
            // Ahora trabajo la lista_final_pendientes
            let lista_final_pendientes = []
            let acumulador_pendientes = {
              estado_uno: 0,
              lote: [],
              valvula: [],
              area_subtotal: 0,
              area_real: 0,
              diferencia: 0,
              estado_dos: 0,
              cod_homologado: '',
              estado_resumen: '',
              area_total: '',

              responsable: '',
              ult_mod: '',
            }

            let ultima_modificacion_p = null;
            let responsable_ultima_modificacion_p = null;

            lista_pendientes.forEach(function (item) {

              acumulador_pendientes.lote += item.lote + ",";
              acumulador_pendientes.valvula += item.valvula + ",";
              acumulador_pendientes.area_subtotal += item.area_subtotal;
              // acumulador_pendientes.area_real += item.area_real;
              acumulador_pendientes.area_real += item.diferencia; //Cuando solo son pendientes el area_real debe ser la sumatoria de la diferencia
              acumulador_pendientes.diferencia += item.diferencia;
              acumulador_pendientes.cod_homologado = item.cod_homologado;
              acumulador_pendientes.cod_homologado_turno = item.cod_homologado_turno;
              acumulador_pendientes.estado_uno_texto = item.estado_uno_texto;
              acumulador_pendientes.estado_dos_texto = item.estado_dos_texto;
              acumulador_pendientes.sociedad = item.sociedad;
              acumulador_pendientes.cultivo = item.cultivo;
              acumulador_pendientes.fundo = item.fundo;
              acumulador_pendientes.etapa = item.etapa;
              acumulador_pendientes.campo = item.campo;
              acumulador_pendientes.turno = item.turno;
              acumulador_pendientes.variedad = item.variedad;
              acumulador_pendientes.estado_resumen = item.estado_dos_texto;
              // acumulador_pendientes.area_total = item.area_ha;
              acumulador_pendientes.area_ha = item.area_ha;
              // acumulador_pendientes.id = item.turno_id;
              acumulador_pendientes.id_turno = item.id_turno;

              acumulador_pendientes.responsable = item.responsable;
              acumulador_pendientes.ult_mod = item.modified;

              // Verificar si esta es la última modificación
              // if (!ultima_modificacion_p || new Date(item.modified) > new Date(ultima_modificacion_p)) {
              //     ultima_modificacion_p = item.modified;
              //     responsable_ultima_modificacion_p = item.responsable;
              // }

            })

            // ----Eliminar la última coma de las cadenas de lote y valvula
            acumulador_pendientes.lote = acumulador_pendientes.lote.slice(0, -1);
            acumulador_pendientes.valvula = acumulador_pendientes.valvula.slice(0, -1);

            // Establecer el responsable y la última modificación en el acumulador
            // acumulador_pendientes.responsable = responsable_ultima_modificacion_p;
            // acumulador_pendientes.ult_mod = ultima_modificacion_p;

            // ----Agregar el acumulador a lista_final_activos
            lista_final_pendientes.push(acumulador_pendientes);

            for (let y of lista_final_pendientes) {
              if (y['estado_dos'] === '0') {
                y['estado_uno_texto'] = 'PENDIENTE'
              }
            }
            resumen_lotes_valvulas.push(acumulador_pendientes)
          }

          //Ahora construyo la lista final que presentaré:
          // lista_final.push(acumulador_activos)
          // lista_final.push(acumulador_pendientes)

          let ultima_modificacion_ag = null;
          let responsable_ultima_modificacion_ag = null;

          for (let z of lista_agrupados) {
            z['estado_resumen'] = 'AGRUPADO'
            z['area_total'] = z['area_ha']
            resumen_lotes_valvulas.push(z)

          }
        }

      }

      // resumen_lotes_valvulas = resumen_lotes_valvulas.concat(turnos_vacios_sinlotesval)

      //
      // let uniqueItems = {};
      // let filteredItems = resumen_lotes_valvulas.filter(item => {
      //     // Creamos una clave única que incluya todos los campos relevantes
      //     // let key = `${item.cod_homologado || 'null'}-${item.lote || 'null'}-${item.valvula || 'null'}-${item.area_ha || 'null'}-${item.cultivo || 'null'}-${item.sociedad || 'null'}`;
      //     let key = `${item.cod_homologado_turno || 'null'}-${item.cultivo || 'null'}-${item.etapa || 'null'}-${item.fundo || 'null'}-${item.sociedad || 'null'}-${item.turno || 'null'}-${item.variedad || 'null'}-${item.estado_uno_texto || 'null'}-${item.estado_dos_texto || 'null'}`;
      //     // Si la clave no está en uniqueItems, la agregamos y mantenemos el elemento
      //     if (!uniqueItems[key]) {
      //         uniqueItems[key] = true;
      //         return true;
      //     }
      //     // Si la clave ya existe, descartamos el elemento
      //     return false;
      // });
      //

      for (let i = 0; i < turnos_vacios_sinlotesval.length; i++) {
        let item = turnos_vacios_sinlotesval[i];
        let exists = resumen_lotes_valvulas.some(existingItem => existingItem.cod_homologado_turno === item.cod_homologado_turno);

        if (!exists) {
          resumen_lotes_valvulas.push(item);
        }
      }

      let uniqueItems = {};
      let filteredItems = resumen_lotes_valvulas.filter(item => {
        let key = `${item.cod_homologado_turno || 'null'}-${item.cultivo || 'null'}-${item.etapa || 'null'}-${item.fundo || 'null'}-${item.sociedad || 'null'}-${item.turno || 'null'}-${item.variedad || 'null'}-${item.estado_uno_texto || 'null'}-${item.estado_dos_texto || 'null'}`;

        if (!uniqueItems[key]) {
          uniqueItems[key] = true;
          return true;
        }

        return false;
      });

      yo.itemsFiltro = filteredItems;
      // yo.itemsFiltro.sort((a, b) => a.cod_homologado.localeCompare(b.cod_homologado));
      yo.itemsResumen = yo.itemsFiltro

      // Si es que hizo filtros, volviendolos a filtrar
      let filt = []
      let spd = yo.itemsResumen
      for (const values of yo.filtro) {
        for (const column of values.valor) {
          spd.forEach(function (value) {
            if (column === 'VACIOS') {
              if (value[values.nombre] === null || value[values.nombre] === '' || value[values.nombre] === ' ' || value[values.nombre] === '  ') {
                filt.push(value)
              }
            } else {
              console.log(values.nombre)
              if (value[values.nombre] === column) {
                filt.push(value)
              }
            }
          })
        }

        if (values.valor.length > 0) {
          if (values.valor[0] !== null) {
            spd = filt
            filt = []
          }
        }
      }

      yo.itemsFiltro = spd

      //Ordeno

      // //Llenando los filtros
      // yo.sociedadFiltro = []
      // yo.fundoFiltro = []
      // yo.cultivoFiltro = []
      // yo.etapaFiltro = []
      // yo.campoFiltro = []
      // yo.variedadFiltro = []
      // yo.turnoFiltro = []

      // for (let value of yo.itemsFiltro) {
      //   if (value.sociedad !== null && value.sociedad !== '' && value.sociedad !== ' ' && value.sociedad !== '  ') { yo.sociedadFiltro.push(value.sociedad) }
      //   if (value.fundo !== null && value.fundo !== '' && value.fundo !== ' ' && value.fundo !== '  ') { yo.fundoFiltro.push(value.fundo) }
      //   if (value.cultivo !== null && value.cultivo !== '' && value.cultivo !== ' ' && value.cultivo !== '  ') { yo.cultivoFiltro.push(value.cultivo) }
      //   if (value.etapa !== null && value.etapa !== '' && value.etapa !== ' ' && value.etapa !== '  ') { yo.etapaFiltro.push(value.etapa) }
      //   if (value.campo !== null && value.campo !== '' && value.campo !== ' ' && value.campo !== '  ') { yo.campoFiltro.push(value.campo) }
      //   if (value.variedad !== null && value.variedad !== '' && value.variedad !== ' ' && value.variedad !== '  ') { yo.variedadFiltro.push(value.variedad) }
      //   if (value.turno !== null && value.turno !== '' && value.turno !== ' ' && value.turno !== '  ') { yo.turnoFiltro.push(value.turno) }
      // }

      // yo.sociedadFiltro = [...new Set(yo.sociedadFiltro)].sort()
      // yo.fundoFiltro = [...new Set(yo.fundoFiltro)].sort()
      // yo.cultivoFiltro = [...new Set(yo.cultivoFiltro)].sort()
      // yo.etapaFiltro = [...new Set(yo.etapaFiltro)].sort()
      // yo.campoFiltro = [...new Set(yo.campoFiltro)].sort()
      // yo.variedadFiltro = [...new Set(yo.variedadFiltro)].sort()
      // yo.turnoFiltro = [...new Set(yo.turnoFiltro)].sort()

    },

    // traerLotesValvulas(){
    //   const yo = this
    //   const data = JSON.stringify(
    //     {
    //       'version_elegida': yo.version_elegida,
    //       'subversion_elegida': yo.subversion_elegida
    //     }
    //   )

    //   const config = {
    //     method: 'post',
    //     url: 'lotes/obtenerLotesValvulas/',
    //     data: data
    //   }

    //   axiosIns(config)
    //     .then(function(response){
    //       if (response.status === 200) {
    //         yo.total_lotes_valvulas = response.data['data']
    //         console.log(yo.total_lotes_valvulas)
    //       }
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     })
    //     .finally(function () {

    //     })

    // },

    // Definir una función para comparar los elementos por las propiedades especificadas
    compararElementos(a, b) {
      return a.cod_homologado_turno === b.cod_homologado_turno &&
          a.lote === b.lote &&
          a.valvula === b.valvula;
    },

    resetModal() {
      this.empresa = null
      this.fundo = null
      this.etapa = null
      this.campo = null
      this.turno = null
      this.cultivo = null
      this.variedad = null
      this.area_total = null
      this.lote = null
      this.valvula = null
      this.area_subtotal = null
      this.area_real = null
      this.diferencia = null
      this.cod_homologado = null
      this.estado_uno = null
      this.estado_dos = null
      this.turno_id = null
      this.diferencia = null

      this.id_editar = null
      this.estado_aprobar = null
      this.area_sembrada = null
      this.lote_c = []
      this.valvula_c = null
      this.area_sembrada_c = null
      this.cod_homologado_c = null
      this.estadoCorrelativo = false
      this.deshabilitar = false

      // this.estados = [
      //   { value: '0', text: "Activo" },
      //   { value: '1', text: "Agrupado" },
      //   { value: '2', text: "Inactivo" },
      //   { value: '3', text: "Eliminado" },
      // ]
      this.estados = [
        {value: '0', text: "ACTIVO"},
        {value: '1', text: "AGRUPADO"},
        {value: '2', text: "INACTIVO"},
        {value: '3', text: "ELIMINADO"},
      ]
    },

    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },

    validacionEditar(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.editarEstado()
    },

    importarOk(bvModalEvtImp) {
      // Prevent modal from closing
      bvModalEvtImp.preventDefault()
      // Trigger submit handler
      this.enviarFile()
    },

    versionarOk(bvModalEvtImp) {
      bvModalEvtImp.preventDefault()
      this.traerLotesValvulas()
    },

    validacionCrear(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.crearRegistro()
    },

    editarEstado() {
      const yo = this
      this.$refs.formularioEditar.validate().then(success => {
        // console.log("EDITANDO ESTADO")

        const data = JSON.stringify(
            {
              'id': yo.id_editar,
              'estado_uno': yo.estado_uno,
              'area_real': yo.area_real,
              'diferencia': yo.diferencia,
              'estado_dos': yo.estado_dos,

              'lote': yo.lote,
              'valvula': yo.valvula,
              'area_subtotal': yo.area_subtotal,
              'con_usuario': yo.id_user,
              'version': yo.version_elegida,
              'sub_version': yo.subversion_elegida,
            }
        )

        const config = {
          method: 'post',
          url: '/pagricolas/lotes/editarlotes_val_ag/',
          data: data
        }

        axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {
                yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se editó correctamente.", 'success', 5000)
                // yo.traerLotesValvulas()
                yo.estadoModalEditar = false
                // Iteramos sobre el arreglo itemsFiltro
                let estado_uno = '';
                let estado_dos = '';
                for (let x of yo.estados) {
                  if (x.value === yo.estado_uno) {
                    estado_uno = x.text
                  }
                }

                for (let y of yo.estados_dos) {
                  if (y.value === yo.estado_dos) {
                    estado_dos = y.text
                  }
                }

                for (let i = 0; i < yo.items.length; i++) {
                  // Verificamos si el cod_homologado_turno coincide
                  if (yo.items[i].id === yo.id_editar) {
                    yo.items[i].lote = yo.lote;
                    yo.items[i].valvula = yo.valvula;
                    yo.items[i].area_subtotal = yo.area_subtotal;
                    yo.items[i].area_real = yo.area_real;
                    yo.items[i].diferencia = yo.diferencia;
                    yo.items[i].estado_uno = yo.estado_uno;
                    yo.items[i].estado_dos = yo.estado_dos;
                    yo.items[i].estado_uno_texto = estado_uno;
                    yo.items[i].estado_dos_texto = estado_dos;
                  }
                  // if (yo.itemsFiltro[i].id === 9) {
                  //     // Si coincide, actualizamos el valor de lote
                  //     // Si deseas editar solo la primera coincidencia, puedes agregar un break aquí
                  // }
                }
              }
            })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('Error en la edición', 'BellIcon', error.toString(), 'danger', 5000)
            })
            .finally(function () {

            })

      })
    },

    //Registrar un Lote o Valvula
    crearRegistro() {
      console.log("CREAR LOTE")
      const yo = this
      this.$refs.formularioCrear.validate().then(success => {
        if (success) {
          yo.loadingCrear = true
          const data = JSON.stringify(
              {
                'cod_homologado': yo.cod_homologado,
                'lote': yo.lote,
                'valvula': yo.valvula,
                'area_total': yo.area_total,
                'area_subtotal': yo.area_subtotal,
                'area_real': yo.area_real,
                'diferencia': yo.diferencia,
                // 'estado_uno': '0', //Activo:0, Agrupado:1, Inactivo:2, Eliminado:3
                'estado_uno': yo.estado_uno, //Activo:0, Agrupado:1, Inactivo:2, Eliminado:3
                'estado_dos': yo.estado_dif, //Pendiente:0, Area Libre:1, Inactivo:2, Eliminado:3
                'cod_homologado_new': yo.cod_homologado_n,
                'turno_id': yo.turnoid,

                'con_usuario': yo.id_user,
                'version': yo.version_elegida,
                'sub_version': yo.subversion_elegida,
              }
          )

          const config = {
            method: 'post',
            url: 'pagricolas/lotes/crearlotes_val_ag/',
            headers: {
              'Content-Type': 'application/json'
            },
            data: data
          }

          axiosIns(config)
              .then(function (response) {
                if (response.status === 200) {
                  yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se creó correctamente.", 'success', 5000)

                  let fechaHoraActual = new Date();
                  let fechaHoraFormateada = fechaHoraActual.toISOString();
                  let estado_dos = '';
                  let estado_uno_texto = '';
                  for (let y of yo.estados_dos) {
                    if (y.value === yo.estado_dif) {
                      estado_dos = y.text
                    }
                  }

                  if (yo.estado_uno === '0') {
                    estado_uno_texto = "ACTIVO"
                  } else if (yo.estado_uno === '2') {
                    estado_uno_texto = "INACTIVO"
                  }
                  console.log(estado_dos)
                  // if(estado_dos == 'PENDIENTE'){
                  //   yo.area_real = yo.diferencia
                  // }
                  console.log(yo.area_real)
                  console.log(yo.diferencia)
                  console.log(yo.items.length)

                  yo.items.push({
                    id: response.data['id_nuevo_reg'],
                    cod_homologado: yo.cod_homologado,
                    cod_homologado_turno: yo.cod_homologado,
                    fundo: yo.fundo,
                    etapa: yo.etapa,
                    campo: yo.campo,
                    turno: yo.turno,
                    id_turno: yo.turnoid,
                    lote: yo.lote,
                    valvula: yo.valvula,
                    area_ha: yo.area_total,
                    area_real: parseFloat(yo.area_real),
                    area_subtotal: yo.area_subtotal,
                    area_total: yo.area_total,
                    cultivo: yo.cultivo,
                    diferencia: parseFloat(yo.diferencia),
                    // estado_uno:0,
                    // estado_uno_texto:'ACTIVO',
                    estado_uno: yo.estado_uno,
                    estado_uno_texto: estado_uno_texto,
                    estado_dos: yo.estado_dif,
                    estado_dos_texto: estado_dos,
                    responsable: yo.nombre_usuario_activo,
                    sociedad: yo.empresa,
                    variedad: yo.variedad,
                    modified: fechaHoraFormateada,
                  })

                  console.log(yo.items.length)

                  // yo.armarDataGeneral()

                }
              })
              .catch(function (error) {
                console.log(error);
                yo.mostrarNotificacion('Error en la creación', 'BellIcon', error.toString(), 'danger', 5000)
              })
              .finally(function () {
                // yo.traerLotesValvulas()
                yo.armarDataGeneral()
                yo.$nextTick(() => {
                  yo.$refs['modal-crear'].toggle('#toggle-btn')
                })
                yo.loadingCrear = false
              })

        }
      })
    },

    //Registrar un Agrupado
    handleSubmit() {
      const yo = this
      let lotes = ""
      this.$refs.formularioDividir.validate().then(success => {
        if (success) {
          yo.loadingDividir = true

          lotes = yo.lote_c.join(',')

          const data = JSON.stringify({
            'cod_homologado': yo.cod_homologado,
            'lote': lotes,
            'valvula': yo.valvula_c,
            'area_total': yo.area_total,
            'area_subtotal': yo.area_subtotal_c,
            'area_real': yo.area_real_c,
            'diferencia': yo.diferencia_c,
            'estado_uno': '1', //Activo:0, Agrupado:1, Inactivo:2, Eliminado:3
            'estado_dos': '2', //Pendiente:0, Area Libre:1,
            'cod_homologado_new': yo.cod_homologado_c,
            'turno_id': yo.turnoid,

            'con_usuario': yo.id_user,
            'version': yo.version_elegida,
            'sub_version': yo.subversion_elegida,
          })

          // console.log(data)

          const config = {
            method: 'post',
            url: 'pagricolas/lotes/crearlotes_val_ag/',
            headers: {
              'Content-Type': 'application/json'
            },
            data: data
          }

          axiosIns(config)
              .then(function (response) {
                if (response.status === 200) {
                  yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se asignó correctamente.", 'success', 5000)

                  let fechaHoraActual = new Date();
                  let fechaHoraFormateada = fechaHoraActual.toISOString();

                  let estado_uno = '';
                  let estado_dos = '';
                  for (let x of yo.estados) {
                    if (x.value === yo.estado_uno) {
                      estado_uno = x.text
                    }
                  }

                  for (let y of yo.estados_dos) {
                    if (y.value === yo.estado_dif) {
                      estado_dos = y.text
                    }
                  }
                  let lotes = "";
                  lotes = yo.lote_c.join(',')

                  yo.items.push({
                    id: response.data['id_nuevo_reg'],
                    cod_homologado: yo.cod_homologado,
                    cod_homologado_turno: yo.cod_homologado,
                    fundo: yo.fundo,
                    etapa: yo.etapa,
                    campo: yo.campo,
                    turno: yo.turno,
                    lote: lotes,
                    valvula: yo.valvula_c,
                    // // area_ha:yo.area_ha,
                    area_ha: yo.area_total,
                    area_real: yo.area_real_c,
                    area_subtotal: yo.area_subtotal_c,
                    area_total: yo.area_total,
                    cultivo: yo.cultivo,
                    // diferencia:0,
                    diferencia: parseFloat(yo.diferencia_c),
                    estado_uno: '1',
                    estado_uno_texto: "AGRUPADO",
                    estado_dos: '2',
                    estado_dos_texto: "INACTIVO",
                    responsable: yo.nombre_usuario_activo,
                    sociedad: yo.empresa,
                    variedad: yo.variedad,
                    modified: fechaHoraFormateada,
                  })
                  // console.log(yo.items.length)
                  // for(let yz of yo.items){
                  //   if(yz['cod_homologado_turno'] == 'ARV-LN-E02C01-T02A'){
                  //     console.log("TU ABUELITA")
                  //     console.log(yz)
                  //   }
                  // }

                  // yo.armarDataGeneral()
                }
              })
              .catch(function (error) {
                console.log(error);
                yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger', 5000)
              })
              .finally(function () {
                yo.armarDataGeneral()
                yo.traerLotesValvulas()
                yo.$nextTick(() => {
                  yo.$refs['modal-dividir'].toggle('#toggle-btn')
                })
                yo.loadingDividir = false
              })

        }
      })
    },

    enviarFile() {
      const yo = this
      this.$refs.formularioImportar.validate().then(success => {
        if (success) {
          this.loadingIMP = true
          const data = new FormData();
          data.append('file', yo.archivo_excel)
          data.append('con_usuario', yo.id_user)
          data.append('version', yo.version_elegida)
          data.append('subversion', yo.subversion_elegida)
          // data.append('parametros_usuario', JSON.stringify(yo.parametros_usuario))

          const config = {
            method: 'post',
            url: '/pagricolas/lotes/importar/',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: data
          }

          axiosIns(config)
              .then(function (response) {
                // console.log(response)
                if (response.status === 200) {
                  // console.log(response.data['errores'])
                  if (response.data['errores'].length > 0) {
                    yo.respuestaErrores = response.data['errores']
                    yo.mostrarErrores = true
                    yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "La importación se realizó con algunas ediciones", 'warning', 5000)
                  } else {
                    yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "La importación se realizó correctamente", 'success', 5000)
                  }

                }
              })
              .catch(function (error) {
                console.log(error);

                yo.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Error en el registro',
                    icon: 'XIcon',
                    text: 'Hubo un error en el registro, intentelo nuevamente en unos minutos.',
                    variant: 'danger',
                  },
                })
              })
              .finally(function () {
                yo.traerLotesValvulas()
                yo.archivo_excel = null
                yo.cultivoIMP = null
                yo.loadingIMP = false
                yo.$nextTick(() => {
                  yo.$refs['modal-importar'].toggle('#toggle-btn')
                })

                // yo.estadoModalRespuesta = true
              })
        }
      })
    },

    mostrarModalImportar() {

      const yo = this;
      this.estadoModalImportar = true
      // if (yo.version_elegida === yo.ultima_version && yo.subversion_elegida === yo.ultima_subversion) {
      //   this.estadoModalImportar = true
      // } else {
      //   yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No puedes importar registros en versiones anteriores a la actual.", 'warning', 5000)

      // }

    },

    calcularDiferencia() {
      const yo = this
      let area_subtotal = yo.area_subtotal
      let area_real = yo.area_real

      if (area_subtotal != null && area_real != null) {
        yo.diferencia = (area_subtotal - area_real).toFixed(3)
      } else {
        yo.diferencia = null
      }
    },

    calcularDiferenciaEnAgrupado() {
      const yo = this
      let area_subtotal = yo.area_subtotal_c
      let area_real = yo.area_real_c

      if (area_subtotal != null && area_real != null) {
        yo.diferencia_c = (area_subtotal - area_real).toFixed(3)
      } else {
        yo.diferencia_c = null
      }
    },

    asignarCodigoHomologadoNuevo() {
      const yo = this
      const data = JSON.stringify({
        'cod_homologado_turno': yo.cod_homologado
      })

      const config = {
        method: 'post',
        url: '/pagricolas/lotes/consultar_codhomo_existentes/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              yo.cod_homologado_n = response.data['cod_homologado_new']
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('Error en la creación', 'BellIcon', error.toString(), 'danger', 5000)
          })
          .finally(function () {

          })

    },

    mostrarModalCrear(datos) {
      const yo = this
      //En caso haya presencia de datos se llenan los input text del formulario
      if (datos) {
        // console.log(datos)
        yo.turnoid = datos.id_turno
        yo.estadoModalCrear = true
        yo.empresa = datos.sociedad
        yo.fundo = datos.fundo
        yo.etapa = datos.etapa
        yo.campo = datos.campo
        yo.turno = datos.turno
        yo.lote = null
        yo.valvula = null
        yo.cultivo = datos.cultivo
        yo.variedad = datos.variedad
        // yo.cod_homologado = datos.cod_homologado
        yo.cod_homologado = datos.cod_homologado_turno
        // yo.area_total = datos.area_total
        yo.area_total = datos.area_ha
      }

      yo.asignarCodigoHomologadoNuevo()
      // yo.area_sembrada = null
      // yo.items_repeat = yo.buscarCodigo(datos.cod_homologado)

      // let cor = 1

      // if(yo.items_repeat.length > 0){
      //   const itrrm = yo.buscarCodigo3(yo.items_repeat[0].cod_homologado)
      //   const arrCor = itrrm[itrrm.length - 1].cod_homologado_new.split("-")
      //   cor = (parseInt(arrCor[arrCor.length - 1]) + 1).toString()
      // }

      // yo.cod_homologado_n = datos.cod_homologado + "-" + cor

    },

    filtrarSubversiones() {
      const yo = this
      let lista_subver = []
      for (let x of yo.lista_vers_subvers) {
        if (x['name'] === yo.version_elegida && !(x['sub_version'] in lista_subver)) {
          lista_subver.push(x['sub_version'])
        }
      }
      yo.lista_subversiones = lista_subver
      yo.subversion_elegida = null
    },

    mostrarModalVersionar() {
      this.estadoModalVersionar = true
    },

    dividirRegistro(datos) {
      const yo = this

      yo.estadoModalDividir = true

      yo.turnoid = datos.id_turno

      yo.empresa = datos.sociedad
      yo.fundo = datos.fundo
      yo.etapa = datos.etapa
      yo.campo = datos.campo
      yo.turno = datos.turno
      yo.cultivo = datos.cultivo
      yo.variedad = datos.variedad
      // yo.cod_homologado = datos.cod_homologado
      yo.cod_homologado = datos.cod_homologado_turno
      yo.lote = datos.lote //Lotes Activos
      yo.valvula = datos.valvula //Valvulas Acticas
      // yo.area_total = datos.area_total
      yo.area_total = datos.area_ha

      yo.valvula_c = 0
      yo.area_subtotal_c = 0
      yo.area_real_c = 0

      //Lleno los select de las lotes y valvulas con estado Activo, NO AGRUPADOS.
      yo.buscarLotesyValvulasActivas()
      // yo.items_repeat = yo.buscarCodigo2(datos.cod_homologado)
    },

    //Esta funcion al momento de crear un agrupado, debo traer los lotes y valvulas activas de ese cod_homologado
    buscarLotesyValvulasActivas() {
      const yo = this
      const data = JSON.stringify({
        'cod_homologado_turno': yo.cod_homologado
      })

      const config = {
        method: 'post',
        url: '/pagricolas/lotes/consultar_codhomo_existentes/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              // yo.cod_homologado_n = response.data['cod_homologado_new']
              yo.cod_homologado_c = response.data['cod_homologado_new']
              yo.lotes_valvulas_encontrados = response.data['lotes_valvulas_exist']
              let lotes_activos = []
              let valvulas_activas = []
              for (let x of yo.lotes_valvulas_encontrados) {
                if (x['estado_uno'] === '0') {
                  lotes_activos.push(x['lote'])
                  valvulas_activas.push(x['valvula'])
                }
              }
              yo.lotes_activos = lotes_activos
              yo.valvulas_activas = valvulas_activas
              yo.lote = yo.lotes_activos.join(',')
              yo.valvula = yo.valvulas_activas.join(',')
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('Error en la creación', 'BellIcon', error.toString(), 'danger', 5000)
          })
          .finally(function () {

          })

    },

    llenarCamposEnAutomatico() {
      const yo = this
      let valvulas = []
      let acumulador_area_subtotal = 0
      let acumulador_area_real = 0

      for (let x of yo.lote_c) {
        for (let y of yo.lotes_valvulas_encontrados) {
          if (x.toString() === y['lote']) {
            valvulas.push(y['valvula'])
            acumulador_area_subtotal = acumulador_area_subtotal + y['area_subtotal']
            acumulador_area_real = acumulador_area_real + y['area_real']
          }
        }
      }
      yo.valvula_c = ''
      yo.area_subtotal_c = acumulador_area_subtotal
      yo.area_real_c = acumulador_area_real

      for (let z of valvulas) {
        yo.valvula_c += z + ",";
      }
      yo.valvula_c = yo.valvula_c.slice(0, -1);

      yo.calcularDiferenciaEnAgrupado()
    },

    seleccionarTurno() {
      if (this.turno === 'TURNO 1-A') {
        this.lote = '3005-3006-3007-3008'
        this.valvula = '04-03-02-01'
        this.variedad = 'BILOXI'
        this.area = '11.09'
      } else {
        this.lote = '3001-3002-3003-3004'
        this.valvula = '08-07-06-05'
        this.variedad = 'BILOXI'
        this.area = '11.32'
      }
    },

    buscarProducto() {
      if (this.codigo === '2510041') {
        this.producto = '4CROPS MICROMIX (I.AHIERRO 20,ZINC 35GL)'
        this.grupo = 'FERT-BIOESTI-BIOREG'
        this.uni_med = 'L'
      } else if (this.codigo === '2510044') {
        this.producto = '4RESIST K (I.A FOSFITO POTASIO)'
        this.grupo = 'FERT-BIOESTI-BIOREG'
        this.uni_med = 'L'
      }
    },

    calcularMaxDia() {
      const kg = this.kg_ha_dia
      const are = this.area
      this.total_max_dia = (kg * are).toLocaleString('es-PE', {maximumFractionDigits: 2})
    },

    formatearCelda(item, type) {
      if (type === 'row') {
        if (item.estado === '2') {
          return "tenue-amarillo"
        } else if (item.estado === '1') {
          return "tenue-rojo"
        }
      }
    },

    mostrarModalEditar(datos, estado) {
      const yo = this
      yo.isAgrup = false
      yo.multiple = estado
      yo.estadoModalEditar = true

      if (datos.estado_uno === '0' || datos.estado_uno === '2' || datos.estado_uno === '3') {
        yo.estados = []
        yo.estados = [
          // { value: '0', text: "Activo" },
          // { value: '2', text: "Inactivo" },
          // { value: '3', text: "Eliminado" },
          {value: '0', text: "ACTIVO"},
          {value: '2', text: "INACTIVO"},
          {value: '3', text: "ELIMINADO"},
        ]
      } else if (datos.estado_uno === '1') {
        yo.isAgrup = true
        yo.estados = []
        yo.estados = [
          // { value: '1', text: "Agrupado" },
          // { value: '2', text: "Inactivo" },
          // { value: '3', text: "Eliminado" },
          {value: '1', text: "AGRUPADO"},
          {value: '2', text: "INACTIVO"},
          {value: '3', text: "ELIMINADO"},
        ]
      }

      yo.id_editar = datos.id
      yo.empresa = datos.sociedad
      yo.fundo = datos.fundo
      yo.area_real = datos.area_real
      yo.diferencia = datos.diferencia
      yo.etapa = datos.etapa
      yo.campo = datos.campo
      yo.turno = datos.turno
      yo.lote = datos.lote
      yo.area_subtotal = datos.area_subtotal
      yo.valvula = datos.valvula
      yo.cultivo = datos.cultivo
      yo.variedad = datos.variedad
      yo.cod_homologado = datos.cod_homologado
      yo.area_total = datos.area_total
      yo.area_sembrada = datos.area_sembrada

      yo.estado_uno = datos.estado_uno
      yo.estado_dos = datos.estado_dos

      yo.lote = datos.lote
      yo.valvula = datos.valvula
      yo.cod_homologado = datos.cod_homologado
    },

    mostrarNotificacion(titulo, icono, texto, variante, tiempo) {
      this.$toast({
            component: ToastificationContent,
            props: {
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: tiempo,
            position: 'top-center',
          })
    },

    unirRegistro(items) {
      this.estadoModalUnir = true
      this.id_unir = items.id_duplicado
    },

    unirTurno() {
      const yo = this

      yo.loadingUnir = true
      const data = JSON.stringify({'id': yo.id_unir})

      const config = {
        method: 'post',
        url: 'pagricolas/lotes/unir_turno/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "Los registros se unieron correctamente.", 'success', 5000)
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger', 5000)
          })
          .finally(function () {
            yo.traerLotesValvulas()
            yo.estadoModalUnir = false
            yo.loadingUnir = false
          })
    },
    repeateAgain() {
      const yo = this

      const id_sig = this.nextTodoId += 1

      this.items_repeat.push({
        id: id_sig,
        value: this.valvula
      })

      this.$nextTick(() => {
        this.trAddHeight(yo.$refs.row_repeat[0].offsetHeight)
      })

      const ids = 'valvula_' + id_sig

      this.$("#valvula_8").val("Hola");
    },
    removeItem(index) {
      const yo = this
      this.items_repeat.splice(index, 1)
      this.trTrimHeight(yo.$refs.row_repeat[0].offsetHeight)
    },
    initTrHeight() {
      const yo = this
      this.trSetHeight(null)
      this.$nextTick(() => {
        //yo.trSetHeight(this.$refs.form_repeat.scrollHeight)
      })
    },
    buscarCodigo(homologado) {
      // console.log(homologado)
      // const yo = this
      // const spd = yo.items
      // let filtrado = []

      // filtrado = spd.filter(item => (item.cod_homologado === homologado)).sort((a, b) => {
      //   let strs_a = parseInt(a.cod_homologado_new.split('-').at(-1))
      //   let strs_b = parseInt(b.cod_homologado_new.split('-').at(-1))

      //   if (strs_a < strs_b) {
      //     return -1;
      //   }
      //   if (strs_a > strs_b) {
      //     return 1;
      //   }

      //   return 0;
      // }
      let filtrado = [{'area_real': homologado, 'valvula': '1', diferencia: ''}]

      return filtrado
    },
    buscarCodigo2(homologado) {
      const yo = this
      const spd = yo.items
      let filtrado = []

      filtrado = spd.filter(item => (item.cod_homologado === homologado && !item.lote.includes(',') && (item.estado === '0' || item.estado === '1'))).sort((a, b) => {
        let strs_a = parseInt(a.cod_homologado_new.split('-').at(-1))
        let strs_b = parseInt(b.cod_homologado_new.split('-').at(-1))

        if (strs_a < strs_b) {
          return -1;
        }
        if (strs_a > strs_b) {
          return 1;
        }

        return 0;
      })

      return filtrado
    },

    buscarCodigo3(homologado) {
      const yo = this
      const spd = yo.items
      let filtrado = []

      filtrado = spd.filter(item => (item.cod_homologado === homologado && (item.estado === '0' || item.estado === '1'))).sort((a, b) => {
        let strs_a = parseInt(a.cod_homologado_new.split('-').at(-1))
        let strs_b = parseInt(b.cod_homologado_new.split('-').at(-1))

        if (strs_a < strs_b) {
          return -1;
        }
        if (strs_a > strs_b) {
          return 1;
        }

        return 0;
      })

      return filtrado
    },

    buscarGrupoPorCodHomologadoTurno(cod_homologado) {
      console.log("Ver detalle")
      const yo = this
      yo.ulti_grupo_desp = cod_homologado
      let total_lotes_valvulas = yo.items
      let resultadosFiltrados = []
      //Del total filtro solo los que cumplen con el cod_homologado
      resultadosFiltrados = total_lotes_valvulas.filter(function (item) {
        return item.cod_homologado === cod_homologado;
      });

      return resultadosFiltrados;
    },

    // buscarGrupoPorCodHomologadoTurno(cod_homologado){
    //   const yo = this
    //   let total_lotes_valvulas = yo.total_lotes_valvulas

    //   let resultadosFiltrados = []
    //   //Del total filtro solo los que cumplen con el cod_homologado
    //   resultadosFiltrados = total_lotes_valvulas.filter(function(item) {
    //     return item.cod_homologado === cod_homologado;
    //   });

    //   if(resultadosFiltrados.length > 0){
    //     // Recorro lo filtrado para volverle a pasar un segundo filtros entre Activos, Pendientes y Agrupados
    //     let lista_activos = []
    //     let lista_pendientes = []
    //     let lista_agrupados = []
    //     let lista_final = [] //Almacen el resumen por grupo segun el cod_homologado

    //     console.log(resultadosFiltrados)
    //     for(let x of resultadosFiltrados){
    //       //Activos
    //       if(x['estado_uno'] == '0'){ // 0  es Activo
    //         lista_activos.push(x)
    //       }
    //       //Pendientes
    //       if(x['estado_dos'] == '0'){
    //         lista_pendientes.push(x)
    //       }
    //       //Agrupados
    //       if(x['estado_uno'] == '1'){
    //         lista_agrupados.push(x)
    //       }
    //     }

    //     // Ahora trabajo la lista_final_activos
    //     let lista_final_activos = []
    //     let acumulador_activos = {
    //       estado_uno: 0,
    //       lote: [],
    //       valvula: [],
    //       area_subtotal: 0,
    //       area_real: 0,
    //       diferencia: 0,
    //       estado_dos: 0,
    //       cod_homologado: '',
    //     }

    //     // ----Recorrer lista_activos y acumular valores
    //     lista_activos.forEach(function(item) {
    //       acumulador_activos.lote += item.lote + ",";
    //       acumulador_activos.valvula += item.valvula + ",";
    //       acumulador_activos.area_subtotal += item.area_subtotal;
    //       acumulador_activos.area_real += item.area_real;
    //       acumulador_activos.diferencia += item.diferencia;
    //       acumulador_activos.cod_homologado = item.cod_homologado;
    //       acumulador_activos.estado_uno_texto = item.estado_uno_texto;
    //       acumulador_activos.estado_dos_texto = item.estado_dos_texto;
    //     })

    //     // ----Eliminar la última coma de las cadenas de lote y valvula
    //     acumulador_activos.lote = acumulador_activos.lote.slice(0, -1);
    //     acumulador_activos.valvula = acumulador_activos.valvula.slice(0, -1);

    //     // ----Agregar el acumulador a lista_final_activos
    //     lista_final_activos.push(acumulador_activos);

    //     // Ahora trabajo la lista_final_pendientes
    //     let lista_final_pendientes = []
    //     let acumulador_pendientes = {
    //       estado_uno: 0,
    //       lote: [],
    //       valvula: [],
    //       area_subtotal: 0,
    //       area_real: 0,
    //       diferencia: 0,
    //       estado_dos: 0,
    //       cod_homologado: '',
    //     }

    //     lista_pendientes.forEach(function(item) {
    //       acumulador_pendientes.lote += item.lote + ",";
    //       acumulador_pendientes.valvula += item.valvula + ",";
    //       acumulador_pendientes.area_subtotal += item.area_subtotal;
    //       acumulador_pendientes.area_real += item.area_real;
    //       acumulador_pendientes.diferencia += item.diferencia;
    //       acumulador_pendientes.cod_homologado = item.cod_homologado;
    //       acumulador_pendientes.estado_uno_texto = item.estado_uno_texto;
    //       acumulador_pendientes.estado_dos_texto = item.estado_dos_texto;
    //     })

    //     // ----Eliminar la última coma de las cadenas de lote y valvula
    //     acumulador_pendientes.lote = acumulador_pendientes.lote.slice(0, -1);
    //     acumulador_pendientes.valvula = acumulador_pendientes.valvula.slice(0, -1);

    //     // ----Agregar el acumulador a lista_final_activos
    //     lista_final_pendientes.push(acumulador_pendientes);

    //     for(let y of lista_final_pendientes){
    //       if(y['estado_dos'] == '0'){
    //         y['estado_uno_texto'] = 'ACTIVO - PENDIENTE'
    //       }
    //     }

    //     //Ahora construyo la lista final que presentaré:
    //     lista_final.push(acumulador_activos)
    //     lista_final.push(acumulador_pendientes)

    //     for(let z of lista_agrupados){
    //       lista_final.push(z)
    //     }

    //     return lista_final
    //   }

    // },

    buscarCodigoCompleto(homologado) {
      const yo = this
      const spd = yo.items
      let filtrado = []

      filtrado = spd.filter(item => (item.cod_homologado === homologado)).sort((a, b) => {
        let strs_a = parseInt(a.cod_homologado_new.split('-').at(-1))
        let strs_b = parseInt(b.cod_homologado_new.split('-').at(-1))

        if (strs_a < strs_b) {
          return -1;
        }
        if (strs_a > strs_b) {
          return 1;
        }

        return 0;
      })

      return filtrado
    },

    // asignarLoteMultiple() {
    //   const yo = this
    //   const siz = yo.lote_c.length
    //   let area = 0
    //   let valvula = ""

    //   const itrrm = yo.buscarCodigo(yo.items_repeat[0].cod_homologado)

    //   const arrCor = itrrm[itrrm.length - 1].cod_homologado_new.split("-")
    //   const cor = (parseInt(arrCor[arrCor.length - 1]) + 1).toString()

    //   yo.lote_c.forEach(function (value) {
    //     area += parseFloat(value.area_sembrada)
    //     valvula += value.valvula + ", "
    //   })

    //   yo.area_sembrada_c = area.toFixed(2)
    //   yo.valvula_c = valvula.substring(0, valvula.length - 2)
    //   yo.cod_homologado_c = yo.cod_homologado + "-" + cor
    //   yo.estadoCorrelativo = false

    //   if (siz === 1) {
    //     yo.deshabilitar = false

    //   } else if (siz > 1) {
    //     yo.deshabilitar = true

    //   }
    // },

    asignarCorrelativo() {
      const yo = this

      if (this.estadoCorrelativo) {
        const arrCor = yo.lote_c[0].cod_homologado_new.split("-")
        const cor = parseInt(arrCor[arrCor.length - 1]).toString()
        yo.cod_homologado_c = yo.cod_homologado + "-" + cor
      } else {
        const arrCor = yo.items_repeat[yo.items_repeat.length - 1].cod_homologado_new.split("-")
        const cor = (parseInt(arrCor[arrCor.length - 1]) + 1).toString()
        yo.cod_homologado_c = yo.cod_homologado + "-" + cor
      }
    },

    exportarDataExcel() {
      const yo = this
      const data = JSON.stringify(
          {
            "datas": yo.items,
            "version_elegida": yo.version_elegida,
            "subversion_elegida": yo.subversion_elegida
          }
      )

      const config = {
        method: 'post',
        url: '/pagricolas/lotes/exportar/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
        data: data
      }

      // const config = {
      //   method: 'get',
      //   url: '/lotes/exportar/',
      //   headers: {
      //     'Content-Type': 'application/json'
      //   },
      //   responseType: 'arraybuffer',
      // }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', "REPORTE_LOTES_VALVULAS VERSION_" + yo.version_elegida + " SUBVERSION_" + yo.subversion_elegida + ".xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loadingExp = false
          });

    },

    realizarFiltro(cabecera, data) {
      // console.log("DV")
      const yo = this
      // let spd = yo.itemsFiltro
      let spd = yo.itemsResumen

      let filt = []
      let c = 0

      for (const valor of yo.filtro) {
        if (valor.nombre === cabecera) {
          yo.filtro[c].valor = data
        }

        c += 1;
      }
      // console.log(yo.filtro)
      for (const values of yo.filtro) {
        for (const column of values.valor) {
          spd.forEach(function (value) {
            if (column === 'VACIOS') {
              if (value[values.nombre] === null || value[values.nombre] === '' || value[values.nombre] === ' ' || value[values.nombre] === '  ') {
                filt.push(value)
              }
            } else {
              // console.log(values.nombre)
              if (value[values.nombre] === column) {
                filt.push(value)
              }
            }
          })
        }

        if (values.valor.length > 0) {
          if (values.valor[0] !== null) {
            spd = filt
            filt = []
          }
        }
      }

      yo.itemsFiltro = spd

    },

    borrarFiltroGeneral() {
      // this.sociedad_filtro = []
      // this.fundo_filtro = []
      // this.cultivo_filtro = []
      // this.etapa_filtro = []
      // this.campo_filtro = []
      // this.variedad_filtro = []
      // this.turno_filtro = []
      // this.itemsFiltro = this.items
      // this.filtro = [
      //   { nombre: "sociedad", valor: [] },
      //   { nombre: "fundo", valor: [] },
      //   { nombre: "cultivo", valor: [] },
      //   { nombre: "etapa", valor: [] },
      //   { nombre: "campo", valor: [] },
      //   { nombre: "variedad", valor: [] },
      //   { nombre: "turno", valor: [] }
      // ]

      //Llenando los filtros
      const yo = this
      yo.sociedad_filtro = []
      yo.fundo_filtro = []
      yo.cultivo_filtro = []
      yo.etapa_filtro = []
      yo.campo_filtro = []
      yo.variedad_filtro = []
      yo.turno_filtro = []

      yo.filtro = [
        {nombre: "sociedad", valor: []},
        {nombre: "fundo", valor: []},
        {nombre: "cultivo", valor: []},
        {nombre: "etapa", valor: []},
        {nombre: "campo", valor: []},
        {nombre: "variedad", valor: []},
        {nombre: "turno", valor: []}
      ]

      yo.itemsFiltro = yo.itemsResumen
      // yo.sociedadFiltro = [...new Set(yo.sociedadFiltro)].sort()
      // yo.fundoFiltro = [...new Set(yo.fundoFiltro)].sort()
      // yo.cultivoFiltro = [...new Set(yo.cultivoFiltro)].sort()
      // yo.etapaFiltro = [...new Set(yo.etapaFiltro)].sort()
      // yo.campoFiltro = [...new Set(yo.campoFiltro)].sort()
      // yo.variedadFiltro = [...new Set(yo.variedadFiltro)].sort()
      // yo.turnoFiltro = [...new Set(yo.turnoFiltro)].sort()
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.alinear-una-sola-linea {
  white-space: nowrap !important;
}

.alinear-medio {
  vertical-align: middle !important;
}

.tenue-amarillo {
  background-color: rgba(204, 190, 41, 0.1);
}

.tenue-rojo {
  background-color: rgba(204, 68, 41, 0.1);
}

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
